/* eslint-disable array-callback-return */

import React, { useState, useEffect, useRef, useCallback } from 'react';
import debounce from 'lodash.debounce';
import isEqual from 'lodash.isequal';
import { clone } from 'ramda';
import { useHistory } from 'react-router-dom';
import { css, StyleSheet } from 'aphrodite/no-important';
import { connect } from 'react-redux';
import {
  TabsContainer,
  TabItem,
  PopupMenu,
  TextInput,
  Button,
  DialogBox,
  Checkbox
} from 'quantux-ui';
import {
  createNewCaseSchedule,
  addPatientToNewCaseSchedule,
  setOpMode,
  updateNewCaseScheduleData,
  toggleNewCaseScheduleWarningDialog1,
  toggleNewCaseScheduleWarningDialog2,
  reloadCaseSchedulePatientData,
  shouldResyncCaseData,
  initiateNewCaseSchedule,
  markCaseBlockCaseForCreation,
  updateCaseBlockCaseMarkedForCreation,
  toggleScheduleCaseDrawer,
  updateCaseBlockActiveCaseSchedule,
  addPatientToCaseBlock,
  deletePatientFromNewCaseSchedule,
  deletePatientFromCaseSchedule,
  deletePatientFromCaseBlock,
  reloadCaseBlockCasePatientData,
  collapseReload
} from '../../actions';
import CaseDoc from '../case-doc';
import CaseTab from './case-tab';
import PatientTab from './patient-tab';
import PayerTab from './payer-tab';
import CaseUserCard from '../revenue-cycle-management/case-user-card';
import PatientCard from '../patient-card';
import CaseField from '../revenue-cycle-management/case-field';
import { blue, gray, salmon } from '../../theme';
import {
  FLAG_VALUE,
  BASE_URL,
  findFlag,
  getHighlightedText,
  debugLogToConsole,
  CASE_SCHEDULE_OP_MODE,
  ORIGIN,
  findFileExtensionByMimeType,
  findBase64ImageMimeType,
  FORM_TYPE
} from '../../utils';
import CameraDrawer from '../doc-writer/camera-drawer';
import CamInspectorDrawer from '../doc-writer/cam-inspector-drawer';
import CropperDrawer from '../doc-writer/cropper-drawer';
// --- New Icons
import DocumentWarningIcon from '../svg-icons/document-warning-icon';
import DocumentSuccessIcon from '../svg-icons/document-success-icon';
import DocumentNoneIcon from '../svg-icons/document-none-icon';
import CaseCriticalIcon from '../svg-icons/case-critical-icon';
import CaseWarningIcon from '../svg-icons/case-warning-icon';
import CaseSuccessIcon from '../svg-icons/case-success-icon';

// #region Shared Icons
const IS_NONE_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
  >
    <path
      fill="#96C8FF"
      fillRule="evenodd"
      d="M8 0C3.584 0 0 3.584 0 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8ZM1.714 8.029c0-3.452 2.855-6.248 6.379-6.248 1.475 0 2.83.492 3.907 1.32l-8.938 8.754A6.091 6.091 0 0 1 1.714 8.03ZM4 12.904a6.385 6.385 0 0 0 3.907 1.32c3.524 0 6.379-2.796 6.379-6.247a6.091 6.091 0 0 0-1.348-3.827L4 12.904Z"
      clipRule="evenodd"
    />
  </svg>
);

const CRITIAL_ICON = (
  <svg
    width="16"
    height="13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 12.364 8 0 0 12.364h16Zm-7.273-2.182H7.273V8.728h1.454v1.454ZM7.273 8h1.454V5.091H7.273v2.91Z"
      fill="#FF0"
    />
  </svg>
);

const BELL_ICON = (
  <svg
    width="16"
    height="16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 7.439v4.376l2 1.75v.875H9.988C9.878 15.314 9.026 16 8 16c-1.036 0-1.88-.686-1.988-1.56H0v-.875l2-1.75V7.439c0-2.696 1.63-4.936 4.5-5.531v-.595C6.5.586 7.17 0 8 0s1.5.586 1.5 1.313v.595c2.86.595 4.5 2.844 4.5 5.53Z"
      fill="#FF6060"
    />
  </svg>
);

const SUCCESS_ICON = (
  <svg
    width="12"
    height="12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 6a6 6 0 1 1 12 0A6 6 0 1 1 0 6Zm2.646-.238 1.896 1.796L9.36 3l.641.608-5.458 5.17L2 6.369l.646-.607Z"
      fill="#00B080"
    />
  </svg>
);
// #endregion

// #region Tab Styles
const COMMON_TAB_ITEM_STYLES = {
  height: '30px',
  borderBottom: 'none',
  marginRight: '0'
};

const TABS = [
  // FaceSheet Tab
  {
    id: 'faceSheet_tab',
    pKey: '1111',
    isIconText: false,
    text: 'FaceSheet',
    hideOnMobile: false,
    styles: {
      ...COMMON_TAB_ITEM_STYLES,
      width: window.innerWidth > 720 ? '12.5%' : '12.5%',
      minWidth: '91px',
      maxWidth: window.innerWidth > 720 ? '12.5%' : '12.5%'
    }
  },
  // Results Tab
  {
    id: 'records_tab',
    pKey: '1331',
    isIconText: false,
    text: 'Results',
    hideOnMobile: false,
    styles: {
      ...COMMON_TAB_ITEM_STYLES,
      width: window.innerWidth > 720 ? '12.5%' : '12.5%',
      minWidth: '91px',
      maxWidth: window.innerWidth > 720 ? '12.5%' : '12.5%',
      borderLeft: '1px solid black'
    }
  },
  // Consents Tab
  {
    id: 'consents_tab',
    pKey: '1112',
    isIconText: false,
    text: 'Consents',
    hideOnMobile: false,
    styles: {
      ...COMMON_TAB_ITEM_STYLES,
      width: window.innerWidth > 720 ? '12.5%' : '12.5%',
      minWidth: '91px',
      maxWidth: window.innerWidth > 720 ? '12.5%' : '12.5%',
      borderLeft: '1px solid black'
    }
  },
  // Anesthesia Tab
  {
    id: 'anesthesia_tab',
    pKey: '1115',
    isIconText: false,
    text: 'Anesthesia',
    hideOnMobile: false,
    styles: {
      ...COMMON_TAB_ITEM_STYLES,
      width: window.innerWidth > 720 ? '12.5%' : '12.5%',
      minWidth: '91px',
      maxWidth: window.innerWidth > 720 ? '12.5%' : '12.5%',
      borderLeft: '1px solid black'
    }
  },
  // Surgeon Tab
  {
    id: 'surgeon_tab',
    pKey: '1114',
    isIconText: false,
    text: 'Surgeon',
    hideOnMobile: true,
    styles: {
      ...COMMON_TAB_ITEM_STYLES,
      width: '12.5%',
      minWidth: '91px',
      maxWidth: '12.5%',
      borderLeft: '1px solid black'
    }
  },
  // Nursing Tab
  {
    id: 'nursing_tab',
    pKey: '1113',
    isIconText: false,
    text: 'Nursing',
    hideOnMobile: true,
    styles: {
      ...COMMON_TAB_ITEM_STYLES,
      width: '12.5%',
      minWidth: '91px',
      maxWidth: '12.5%',
      borderLeft: '1px solid black'
    }
  },
  // Orders Tab
  {
    id: 'orders_tab',
    pKey: '8899',
    isIconText: false,
    text: 'Orders',
    hideOnMobile: true,
    styles: {
      ...COMMON_TAB_ITEM_STYLES,
      width: '12.5%',
      minWidth: '91px',
      maxWidth: '12.5%',
      borderLeft: '1px solid black'
    }
  },
  // Discharge Tab
  {
    id: 'discharge_tab',
    pKey: '1116',
    isIconText: false,
    text: 'Discharge',
    hideOnMobile: true,
    styles: {
      ...COMMON_TAB_ITEM_STYLES,
      width: '12.5%',
      minWidth: '91px',
      maxWidth: '12.5%',
      borderLeft: '1px solid black'
    }
  }
];

const TABS_TEXT_STYLES = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontSize: '12px'
};
// #endregion

const MOBILE_BREAK_POINT = 1012;
const BREAK_POINT = 720;
const DRAWER_WIDTH = 355;
const DIALOG_WIDTH = window.innerWidth <= 576 ? (window.innerWidth - 16) : 350;

const ScheduleCaseDrawer2 = (props) => {
  const [sectionsContainerHeight, setSectionsContainerHeight] = useState(window.innerHeight);
  const [masterFlag, setMasterFlag] = useState(FLAG_VALUE.critical);
  const [isMobileLayout, setIsMobileLayout] = useState(window.innerWidth <= MOBILE_BREAK_POINT);
  const [showScheduleDrawer, setShowScheduleDrawer] = useState(false);
  // --- Case Docs Tabs
  const [activeTab, setActiveTab] = useState(TABS[0].text);
  const [consentActiveTab, setConsentActiveTab] = useState('anesthesia');
  const [anesthesiaSubTab, setAnesthesiaSubTab] = useState('preOp');
  const [recordsSubTab, setRecordsSubTab] = useState('labs');
  const [ordersSubTab, setOrdersSubTab] = useState('preOp');
  // --- Schedule Forms Drawer
  const [drawerActiveTab, setDrawerActiveTab] = useState('case');
  const [patientFlag, setPatientFlag] = useState(FLAG_VALUE.warning);
  const [payerFlag, setPayerFlag] = useState(FLAG_VALUE.warning);
  // -- Case Docs (NEW)
  const [faceSheetDocs, setFaceSheetDocs] = useState([]);
  window.faceSheetDocs = faceSheetDocs;
  const [isNoneFaceSheet, setIsNoneFaceSheet] = useState(false);
  // Surgery Consent Form
  const [consentSurgFormDocs, setConsentSurgFormDocs] = useState([]);
  const [isNoneConsentSurgFormDocs, setIsNoneConsentSurgFormDocs] = useState(true);
  // Anesthesia Consent Form
  const [consentFormDocs, setConsentFormDocs] = useState([]);
  const [isNoneConsentFormDocs, setIsNoneConsentFormDocs] = useState(false);
  // PreOp Form Docs
  const [preOpFormDocs, setPreOpFormDocs] = useState([]);
  const [isNonePreOpFormDocs, setIsNonePreOpFormDocs] = useState(false);
  // IntraOp Form Docs
  const [intraOpFormDocs, setIntraOpFormDocs] = useState([]);
  const [isNoneIntraOpFormDocs, setIsNoneIntraOpFormDocs] = useState(false);
  // Post Op Form Docs
  const [postOpFormDocs, setPostOpFormDocs] = useState([]);
  const [isNonePostOpFormDocs, setIsNonePostOpFormDocs] = useState(false);
  // Anesthesia Procedures
  const [anesthesiaProcedureValue, setAnesthesiaProcedureValue] = useState('');
  const [showAnesthesiaProceduresSearchMenu, setShowAnesthesiaProceduresSearchMenu] = useState(false);
  const [anesthesiaProceduresSearchResults, setAnesthesiaProceduresSearchResults] = useState([]);
  const [anesthesiaProcedures, setAnesthesiaProcedures] = useState([]);
  const [isNoneAnesthesiaProcedure, setIsNoneAnesthesiaProcedure] = useState(false);
  // Records -- Lab
  const [labsDocs, setLabsDocs] = useState([]);
  const [isNoneLabDocs, setIsNoneLabDocs] = useState(true);
  // Records -- EKG
  const [ekgDocs, setEkgDocs] = useState([]);
  const [isNoneEkgDocs, setIsNoneEkgDocs] = useState(true);
  // Records -- Imaging
  const [imagingDocs, setImagingDocs] = useState([]);
  const [isNoneImagingDocs, setIsNoneImagingDocs] = useState(true);
  // Records -- Consults
  const [consultsDocs, setConsultsDocs] = useState([]);
  const [isNoneConsults, setIsNoneConsults] = useState(true);
  // Nursing
  const [isNoneNursingDocs, setIsNoneNursingDocs] = useState(true);
  const [nursingDocs, setNursingDocs] = useState([]);
  // Surgeon
  const [isNoneSurgeonDocs, setIsNoneSurgeonDocs] = useState(true);
  const [surgeonDocs, setSurgeonDocs] = useState([]);
  // Orders - PreOp Form Docs
  const [ordersPreOpDocs, setOrdersPreOpDocs] = useState([]);
  const [isNoneOrdersPreOpDocs, setIsNoneOrdersPreOpDocs] = useState(true);
  // Orders - IntraOp Form Docs
  const [ordersIntraOpDocs, setOrdersIntraOpDocs] = useState([]);
  const [isNoneOrdersIntraOpDocs, setIsNoneOrdersIntraOpDocs] = useState(true);
  // Orders - Post Op Form Docs
  const [ordresPostOpDocs, setOrdresPostOpDocs] = useState([]);
  const [isNoneOrdersPostOpDocs, setIsNoneOrdersPostOpDocs] = useState(true);
  // Discharge
  const [dischargeDocs, setDischargeDocs] = useState([]);
  const [isNoneDischargeDocs, setIsNoneDischargeDocs] = useState(true);
  // -- Disccard | Post Case | Post Case
  const [shouldSaveCase, setShouldSaveCase] = useState(false);
  // Patient Card -- patient data
  const [patientData, setPatientData] = useState({});
  // --- Scan document feature
  const [showCameraDrawer, setShowCameraDrawer] = useState(false);
  const [showCamInspectorDrawer, setShowCamInspectorDrawer] = useState(false);
  const [showCropperDrawer, setShowCropperDrawer] = useState(false);
  const [newCaseScannedDocs, setNewCaseScannedDocs] = useState({});
  const [cropperDocs, setCropperDocs] = useState({});

  /* ___ REFS _____________________________________________________ */
  const procedureSearchMenuRef = useRef();
  const initLoadRef = useRef({
    faceSheet: false,
    recordsLab: false,
    recordsEkg: false,
    recordsImaging: false,
    recordsConsults: false,
    consentSurgery: false,
    consentAnesthesia: false,
    nursing: false,
    surgeon: false,
    anesthesiaPreOp: false,
    anesthesiaIntraOp: false,
    anesthesiaPostOp: false,
    anesthesiaProcedures: false,
    ordersPreOp: false,
    ordersIntraOp: false,
    ordersPostOp: false,
    discharge: false
  });

  // ___ REACT ROUTER _________________________________________________________
  const history = useHistory();

  // ___ STYLES _______________________________________________________________
  const styles = StyleSheet.create({
    dashboardContainer: {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100vw',
      height: '100vh',
      background: blue[900],
      zIndex: '5000',
      overflow: 'hidden'
    },
    header: {
      height: '40px',
      background: '#004080',
      borderBottom: '1px solid #000',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 4px'
    },
    headerText: {
      fontSize: '14px',
      fontWeight: 'bold',
      lineHeight: '16px'
    },
    sectionsContainer: {
      height: `${sectionsContainerHeight - 40}px`,
      display: 'flex',
      overflow: 'hidden'
    },
    tabsContainer: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'column',
      flexGrow: '1',
      maxWidth: '100vw'
    },
    scheduleFormContainerMobile: {
      top: '40px',
      right: '0px',
      height: 'calc(100vh - 40px)'
    },
    scheduleFormContainer: {
      width: '355px',
      borderLeft: `${showScheduleDrawer ? '1px' : '0'} solid ${blue[400]}`,
      background: gray[800],
      position: isMobileLayout ? 'absolute' : 'relative',
      top: '0px',
      display: 'flex',
      flexFlow: 'column'
    },
    scheduleFormContainerClosed: {
      width: '0',
      display: isMobileLayout ? 'none' : ''
    },
    scheduleFormHeader: {
      display: 'flex',
      alignItems: 'center',
      height: '40px',
      minHeight: '40px',
      backgroundColor: blue[700],
      padding: '0 8px',
      flexGrow: '0'
    },
    scheduleFormHeaderTitle: {
      flexGrow: '1',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start'
    },
    scheduleFormHeaderCloseIcon: {
      flexGrow: '0',
      ':hover': {
        color: salmon[500]
      }
    },
    patientStickerContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      paddingRight: '4px',
      height: '141px',
      minHeight: '141px',
      background: blue[900],
      flexGrow: '0'
    },
    docTabs: {
      background: 'black',
      padding: '1px 0',
      flexGrow: '0'
    },
    docContainer: {
      height: 'calc(100% - 174px)'
    },
    pdfDocContainer: {
      width: '100%',
      // height: '100%'
      height: 'calc(100% - 32px)'
    },
    scheduleDrawerTabs: {
      // maxHeight: 'calc(100% - 56px)',
      height: '30px',
      minHeight: '30px',
      flexGrow: '0',
      overflowY: 'auto',
      overflowX: 'hidden',
      marginTop: '8px',
      display: 'flex',
      justifyContent: 'center'
    },
    activeComponentContainer: {
      height: 'calc(100% - 71px)',
      overflowY: 'auto',
      flexGrow: '1',
      overflowX: 'none'
    },
    menuItem: {
      cursor: 'pointer',
      background: gray[900],
      color: gray[300],
      padding: '4px',
      lineHeight: '16px',
      fontSize: '14px',
      marginTop: '1px',
      ':hover': {
        background: '#184878',
        color: 'white'
      },
      ':last-child': {
        borderBottom: '0'
      }
    },
    searchPopupMenuContainer: {
      width: `${DRAWER_WIDTH - 21}px`,
      background: blue[900],
      paddingBottom: '1px',
      borderRadius: '5px',
      overflowY: 'auto',
      maxHeight: '480px'
    }
  });

  // ___ WINDOW EVENTS ________________________________________________________
  const handleWindowResize = () => {
    setSectionsContainerHeight(window.innerHeight);
    setIsMobileLayout(window.innerWidth <= MOBILE_BREAK_POINT);
  };

  // Searching surgical procedures
  const searchSurgicalProcedures = (value) => {
    const url = new URL(`${BASE_URL}/anesProc/searchAnesthesiaProcedures`);
    const params = { searchTerm: value.trim() };
    url.search = new URLSearchParams(params).toString();
    fetch(url)
      .then(res => res.text())
      .then((result) => {
        const data = JSON.parse(result);
        setShowAnesthesiaProceduresSearchMenu(true);
        setAnesthesiaProceduresSearchResults(data.anesthesiaProcedures);
      })
      .catch(error => debugLogToConsole('error', error));
  };
  const debouncedProceduresSearch = useCallback(debounce(value => searchSurgicalProcedures(value), 800), []);

  /* ___ EFFECTS __________________________________________________ */
  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    handleWindowResize();

    if (!props.forCaseBlocks && props.opMode !== CASE_SCHEDULE_OP_MODE.newSchedule) {
      props.initiateNewCaseSchedule({
        selectedFacilityLocation: 'TBD (To Be Determined)'
      });
    }

    if (props.opMode === CASE_SCHEDULE_OP_MODE.caseBlockNewCase) {
      const tmp = clone(props.caseBlockActiveCaseSchedule);
      debugLogToConsole(tmp);
      window.icd = tmp;
    }

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  // -- Patient & Payer Flag
  useEffect(() => {
    let piFlag = FLAG_VALUE.warning;
    let siFlag = FLAG_VALUE.warning;
    let tiFlag = FLAG_VALUE.warning;
    let spFlag = FLAG_VALUE.warning;

    // Primary Insurance Flag
    if (props.newCaseSchedulePatient.isNoPrimaryInsurance) {
      piFlag = FLAG_VALUE.success;
    } else {
      if (props.newCaseSchedulePatient.primaryInsurance && Object.keys(props.newCaseSchedulePatient.primaryInsurance).length > 0) {
        piFlag = FLAG_VALUE.success;
      } else {
        piFlag = FLAG_VALUE.warning;
      }
    }

    // Secondary Insurance Flag
    if (props.newCaseSchedulePatient.isNoSecondaryInsurance) {
      siFlag = FLAG_VALUE.success;
    } else {
      if (props.newCaseSchedulePatient.secondaryInsurance && Object.keys(props.newCaseSchedulePatient.secondaryInsurance).length > 0) {
        siFlag = FLAG_VALUE.success;
      } else {
        siFlag = FLAG_VALUE.warning;
      }
    }

    // Tertiary Insurance Flag
    if (props.newCaseSchedulePatient.isNoTertiaryInsurance) {
      tiFlag = FLAG_VALUE.success;
    } else {
      if (props.newCaseSchedulePatient.tertiaryInsurance && Object.keys(props.newCaseSchedulePatient.tertiaryInsurance).length > 0) {
        tiFlag = FLAG_VALUE.success;
      } else {
        tiFlag = FLAG_VALUE.warning;
      }
    }

    // Self Pay Flag
    if (props.newCaseSchedulePatient.isNoSelfPay) {
      spFlag = FLAG_VALUE.success;
    } else {
      spFlag = FLAG_VALUE.warning;
    }

    setPayerFlag(findFlag(piFlag, siFlag, tiFlag, spFlag));
    setPatientFlag(Object.keys(props.newCaseSchedulePatient).length > 0
      ? FLAG_VALUE.success
      : FLAG_VALUE.warning
    );
  }, [props.newCaseSchedulePatient]);

  // Schedule drawer ** Master Flag **
  useEffect(() => {
    setMasterFlag(findFlag(props.caseTabFlag, patientFlag, payerFlag));
  }, [
    props.caseTabFlag,
    patientFlag,
    payerFlag
  ]);

  useEffect(() => {
    setPatientData({
      dos: props.newCaseSchedule && props.newCaseSchedule.scheduleStartDate
        ? props.newCaseSchedule.scheduleStartDate
        : new Date().toISOString(),
      patientType: props.newCaseSchedule && props.newCaseSchedule.patientType
        ? props.newCaseSchedule.patientType
        : '',
      facilityName: props.newCaseSchedule && props.newCaseSchedule.facility
        ? props.newCaseSchedule.facility.facilityName || ''
        : '',
      surgeons: props.newCaseSchedule && props.newCaseSchedule.surgeons
        ? props.newCaseSchedule.surgeons
        : [],
      admDx: props.newCaseSchedule && props.newCaseSchedule.preOpDx
        ? props.newCaseSchedule.preOpDx
        : [],
      surgicalProcedures: props.newCaseSchedule && props.newCaseSchedule.surgicalProcedures
        ? props.newCaseSchedule.surgicalProcedures
        : [],
      otherSurgicalProcedures: props.newCaseSchedule && props.newCaseSchedule.otherSurgicalProcedures
        ? props.newCaseSchedule.otherSurgicalProcedures
        : [],
      anesthesia: props.newCaseSchedule && props.newCaseSchedule.anesthesiologists
        ? props.newCaseSchedule.anesthesiologists
        : [],
      dob: props.newCaseSchedulePatient
        ? props.newCaseSchedulePatient.dob || ''
        : '',
      gender: props.newCaseSchedulePatient
        ? props.newCaseSchedulePatient.gender || ''
        : '',
      firstName: props.newCaseSchedulePatient
        ? props.newCaseSchedulePatient.firstName || ''
        : '',
      middleName: props.newCaseSchedulePatient
        ? props.newCaseSchedulePatient.middleName || ''
        : '',
      lastName: props.newCaseSchedulePatient
        ? props.newCaseSchedulePatient.lastName || ''
        : ''
    });
  }, [
    props.newCaseSchedule,
    props.newCaseSchedulePatient
  ]);

  useEffect(() => {
    debugLogToConsole('🟠🟠🟠🟠🟠');
    debugLogToConsole('Reading case block case patient data');
    const acs = props.caseBlockActiveCaseSchedule;
    const { patientId } = acs;
    const tmpPatientData = {
      dos: acs && acs.scheduleStartDate ? acs.scheduleStartDate : new Date().toISOString(),
      patientType: acs && acs.patientType ? acs.patientType : '',
      facilityName: acs && acs.facility ? acs.facility.facilityName || '' : '',
      surgeons: acs && acs.surgeons ? acs.surgeons : [],
      admDx: acs && acs.preOpDx ? acs.preOpDx : [],
      surgicalProcedures: acs && acs.surgicalProcedures ? acs.surgicalProcedures : [],
      otherSurgicalProcedures: acs && acs.otherSurgicalProcedures ? acs.otherSurgicalProcedures : [],
      anesthesia: acs && acs.anesthesiologists ? acs.anesthesiologists : []
    };

    if (patientId) {
      const cbPatient = props.caseBlockPatients[patientId];
      tmpPatientData.dob = cbPatient ? cbPatient.dob || '' : '';
      tmpPatientData.gender = cbPatient ? cbPatient.gender || '' : '';
      tmpPatientData.firstName = cbPatient ? cbPatient.firstName || '' : '';
      tmpPatientData.middleName = cbPatient ? cbPatient.middleName || '' : '';
      tmpPatientData.lastName = cbPatient ? cbPatient.lastName || '' : '';
    }

    setPatientData(tmpPatientData);
  }, [
    props.caseBlockActiveCaseSchedule,
    props.caseBlockPatients
  ]);

  useEffect(() => {
    if (anesthesiaProcedureValue.length === 0) {
      setAnesthesiaProceduresSearchResults([]);
    }
    if (anesthesiaProcedureValue.trim().length > 0) {
      debouncedProceduresSearch(anesthesiaProcedureValue);
    }
  }, [anesthesiaProcedureValue]);

  // Facesheet Docs
  useEffect(() => {
    if (initLoadRef.current.faceSheet) {
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ faceSheetDocs });
      } else {
        props.updateNewCaseScheduleData({ faceSheetDocs });
      }
    }
    initLoadRef.current.faceSheet = true;
  }, [faceSheetDocs]);

  // Records Lab Docs
  useEffect(() => {
    if (initLoadRef.current.recordsLab) {
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ labsDocs });
      } else {
        props.updateNewCaseScheduleData({ labsDocs });
      }
    }
    initLoadRef.current.recordsLab = true;
  }, [labsDocs]);

  // Records EKG Docs
  useEffect(() => {
    if (initLoadRef.current.recordsEkg) {
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ ekgDocs });
      } else {
        props.updateNewCaseScheduleData({ ekgDocs });
      }
    }
    initLoadRef.current.recordsEkg = true;
  }, [ekgDocs]);

  // Records Imaging Docs
  useEffect(() => {
    if (initLoadRef.current.recordsImaging) {
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ imagingDocs });
      } else {
        props.updateNewCaseScheduleData({ imagingDocs });
      }
    }
    initLoadRef.current.recordsImaging = true;
  }, [imagingDocs]);

  // Records Consults Docs
  useEffect(() => {
    if (initLoadRef.current.recordsConsults) {
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ consultsDocs });
      } else {
        props.updateNewCaseScheduleData({ consultsDocs });
      }
    }
    initLoadRef.current.recordsConsults = true;
  }, [consultsDocs]);

  // Consent Surgery Docs
  useEffect(() => {
    if (initLoadRef.current.consentSurgery) {
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ consentSurgFormDocs });
      } else {
        props.updateNewCaseScheduleData({ consentSurgFormDocs });
      }
    }
    initLoadRef.current.consentSurgery = true;
  }, [consentSurgFormDocs]);

  // Consent Anesthesia Docs
  useEffect(() => {
    if (initLoadRef.current.consentAnesthesia) {
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ consentFormDocs });
      } else {
        props.updateNewCaseScheduleData({ consentFormDocs });
      }
    }
    initLoadRef.current.consentAnesthesia = true;
  }, [consentFormDocs]);

  // Nursing Docs
  useEffect(() => {
    if (initLoadRef.current.nursing) {
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ nursingDocs });
      } else {
        props.updateNewCaseScheduleData({ nursingDocs });
      }
    }
    initLoadRef.current.nursing = true;
  }, [nursingDocs]);

  // Surgeon Docs
  useEffect(() => {
    if (initLoadRef.current.surgeon) {
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ surgeonDocs });
      } else {
        props.updateNewCaseScheduleData({ surgeonDocs });
      }
    }
    initLoadRef.current.surgeon = true;
  }, [surgeonDocs]);

  // Anesthesia PreOp Docs
  useEffect(() => {
    if (initLoadRef.current.anesthesiaPreOp) {
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ preOpFormDocs });
      } else {
        props.updateNewCaseScheduleData({ preOpFormDocs });
      }
    }
    initLoadRef.current.anesthesiaPreOp = true;
  }, [preOpFormDocs]);

  // Anesthesia IntraOp Docs
  useEffect(() => {
    if (initLoadRef.current.anesthesiaIntraOp) {
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ intraOpFormDocs });
      } else {
        props.updateNewCaseScheduleData({ intraOpFormDocs });
      }
    }
    initLoadRef.current.anesthesiaIntraOp = true;
  }, [intraOpFormDocs]);

  // Anesthesia PostOp Docs
  useEffect(() => {
    if (initLoadRef.current.anesthesiaPostOp) {
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ postOpFormDocs });
      } else {
        props.updateNewCaseScheduleData({ postOpFormDocs });
      }
    }
    initLoadRef.current.anesthesiaPostOp = true;
  }, [postOpFormDocs]);

  useEffect(() => {
    if (initLoadRef.current.anesthesiaProcedures) {
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({
          anesthesiaProcedures: anesthesiaProcedures.filter(el => el.npi !== 0),
          otherAnesthesiaProcedures: anesthesiaProcedures.filter(el => el.npi === 0)
        });
      } else {
        props.updateNewCaseScheduleData({
          anesthesiaProcedures: anesthesiaProcedures.filter(el => el.npi !== 0),
          otherAnesthesiaProcedures: anesthesiaProcedures.filter(el => el.npi === 0)
        });
      }
    }
    initLoadRef.current.anesthesiaProcedures = true;
  }, [anesthesiaProcedures]);

  // Orders PreOp Docs
  useEffect(() => {
    if (initLoadRef.current.ordersPreOp) {
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ ordersPreOpDocs });
      } else {
        props.updateNewCaseScheduleData({ ordersPreOpDocs });
      }
    }
    initLoadRef.current.ordersPreOp = true;
  }, [ordersPreOpDocs]);

  // Orders IntraOp Docs
  useEffect(() => {
    if (initLoadRef.current.ordersIntraOp) {
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ ordersIntraOpDocs });
      } else {
        props.updateNewCaseScheduleData({ ordersIntraOpDocs });
      }
    }
    initLoadRef.current.ordersIntraOp = true;
  }, [ordersIntraOpDocs]);

  // Orders PostOp Docs
  useEffect(() => {
    if (initLoadRef.current.ordersPostOp) {
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ ordresPostOpDocs });
      } else {
        props.updateNewCaseScheduleData({ ordresPostOpDocs });
      }
    }
    initLoadRef.current.ordersPostOp = true;
  }, [ordresPostOpDocs]);

  // Dischange Docs
  useEffect(() => {
    if (initLoadRef.current.discharge) {
      if (props.forCaseBlocks) {
        props.updateCaseBlockActiveCaseSchedule({ dischargeDocs });
      } else {
        props.updateNewCaseScheduleData({ dischargeDocs });
      }
    }
    initLoadRef.current.discharge = true;
  }, [dischargeDocs]);

  /* ___ EVENT HANDLERS ___________________________________________ */
  const handleOnCaseDataChange = () => {
    if (!shouldSaveCase) {
      setShouldSaveCase(true);
    }
  };

  // Post case handler
  const openCasePatientDrawer = () => {
    setShowScheduleDrawer(!showScheduleDrawer);
  };

  const closeScheduleCaseDrawer = () => {
    setShowScheduleDrawer(false);
  };

  const handleOnActivateDrawerTab = (currentTab) => {
    if (currentTab === 'case') {
      setDrawerActiveTab('case');
      props.shouldResyncCaseData(true);
    } else if (currentTab === 'patient') {
      setDrawerActiveTab('patient');
    } else if (currentTab === 'payers') {
      setDrawerActiveTab('payers');
    }
  };

  const handleOnAddPatient = (data) => {
    if (props.forCaseBlocks) {
      props.addPatientToCaseBlock(data);
    } else {
      props.addPatientToNewCaseSchedule(data);
    }
  };

  const handleOnDeletePatient = (patientId, isExistingCaseSchedule = false) => {
    if (props.forCaseBlocks) {
      props.deletePatientFromCaseBlock(patientId);
    } else {
      if (isExistingCaseSchedule) {
        props.deletePatientFromCaseSchedule();
      } else {
        props.deletePatientFromNewCaseSchedule();
      }
    }
  };

  const handleOnReloadPatientData = () => {
    if (props.forCaseBlocks) {
      props.reloadCaseBlockCasePatientData(props.caseBlockActiveCaseSchedule.patientId);
    } else {
      props.reloadCaseSchedulePatientData(props.newCaseSchedulePatient._id);
    }
  };

  // *** FACESHEET DOCS EVENT HANDLERS ***
  const handleOnChangeIsNoneFaceSheet = (value) => {
    setIsNoneFaceSheet(value);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isNoneFaceSheet: value });
    } else {
      props.updateNewCaseScheduleData({ isNoneFaceSheet: value });
    }
  };

  const handleOnFaceSheetDocsUploaded = (docs) => {
    setFaceSheetDocs(docs);
  };

  const handleOnDeleteFaceSheetDocPage = (docId) => {
    setFaceSheetDocs(prvState => prvState.filter(el => el.id !== docId));
  };

  const handleOnDeleteFaceSheetDocDocument = () => {
    setFaceSheetDocs([]);
  };

  // *** CONSENT FORM DOCS EVENT HANDLERS ***
  const handleOnConsentFormDocsUploaded = (docs) => {
    setConsentFormDocs(docs);
  };

  const handleOnChangeIsNoneConsentForm = (value) => {
    setIsNoneConsentFormDocs(value);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isNoneConsentFormDocs: value });
    } else {
      props.updateNewCaseScheduleData({ isNoneConsentFormDocs: value });
    }
  };

  const handleOnDeleteConsentFormDocPage = (docId) => {
    setConsentFormDocs((prvState) => prvState.filter(el => el.id !== docId));
  };

  const handleOnDeleteConsentFormDocDocument = () => {
    setConsentFormDocs([]);
  };

  const handleOnConsentSurgFormDocsUploaded = (docs) => {
    setConsentSurgFormDocs(docs);
  };

  const handleOnChangeIsNoneConsentSurgForm = (value) => {
    setIsNoneConsentSurgFormDocs(value);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isNoneConsentSurgFormDocs: value });
    } else {
      props.updateNewCaseScheduleData({ isNoneConsentSurgFormDocs: value });
    }
  };

  const handleOnDeleteConsentSurgFormDocPage = (docId) => {
    setConsentSurgFormDocs((prvState) => prvState.filter(el => el.id !== docId));
  };

  const handleOnDeleteConsentSurgFormDocDocument = () => {
    setConsentSurgFormDocs([]);
  };

  const handleOnPreOpFormDocsUploaded = (docs) => {
    setPreOpFormDocs(docs);
  };

  const handleOnChangeIsNonePreOpForm = (value) => {
    setIsNonePreOpFormDocs(value);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isNonePreOpFormDocs: value });
    } else {
      props.updateNewCaseScheduleData({ isNonePreOpFormDocs: value });
    }
  };

  const handleOnDeletePreOpFormmDocPage = (docId) => {
    setPreOpFormDocs((prvState) => prvState.filter(el => el.id !== docId));
  };

  const handleOnDeletePreOpFormmDocDocument = () => {
    setPreOpFormDocs([]);
  };

  const handleOnIntraOpFormDocsUploaded = (docs) => {
    setIntraOpFormDocs(docs);
  };

  const handleOnChangeIsNoneIntraOpForm = (value) => {
    setIsNoneIntraOpFormDocs(value);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isNoneIntraOpFormDocs: value });
    } else {
      props.updateNewCaseScheduleData({ isNoneIntraOpFormDocs: value });
    }
  };

  const handleOnDeleteIntraOpFormmDocPage = (docId) => {
    setIntraOpFormDocs((prvState) => prvState.filter(el => el.id !== docId));
  };

  const handleOnDeleteIntraOpFormmDocDocument = () => {
    setIntraOpFormDocs([]);
  };

  const handleOnPostOpFormDocsUploaded = (docs) => {
    setPostOpFormDocs(docs);
  };

  const handleOnChangeIsNonePostOpForm = (value) => {
    setIsNonePostOpFormDocs(value);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isNonePostOpFormDocs: value });
    } else {
      props.updateNewCaseScheduleData({ isNonePostOpFormDocs: value });
    }
  };

  const handleOnDeletePostOpFormmDocPage = (docId) => {
    setPostOpFormDocs((prvState) => prvState.filter(el => el.id !== docId));
  };

  const handleOnDeletePostOpFormmDocDocument = () => {
    setPostOpFormDocs([]);
  };

  const handleOnLabsDocsUploaded = (docs) => {
    setLabsDocs(docs);
  };

  const handleOnChangeIsNoneLabsDocs = (value) => {
    setIsNoneLabDocs(value);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isNoneLabsDocs: value });
    } else {
      props.updateNewCaseScheduleData({ isNoneLabsDocs: value });
    }
  };

  const handleOnDeleteLabsDocsPage = (docId) => {
    setLabsDocs((prvState) => prvState.filter(el => el.id !== docId));
  };

  const handleOnDeleteLabsDocsDocument = () => {
    setLabsDocs([]);
  };

  const handleOnEkgDocsUploaded = (docs) => {
    setEkgDocs(docs);
  };

  const handleOnChangeIsNoneEkgDocs = (value) => {
    setIsNoneEkgDocs(value);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isNoneEkgDocs: value });
    } else {
      props.updateNewCaseScheduleData({ isNoneEkgDocs: value });
    }
  };

  const handleOnDeleteEkgDocsPage = (docId) => {
    setEkgDocs((prvState) => prvState.filter(el => el.id !== docId));
  };

  const handleOnDeleteEkgDocsDocument = (docId) => {
    setEkgDocs([]);
  };

  const handleOnImagingDocsUploaded = (docs) => {
    setImagingDocs(docs);
  };

  const handleOnChangeIsNoneImagingDocs = (value) => {
    setIsNoneImagingDocs(value);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isNoneImagingDocs: value });
    } else {
      props.updateNewCaseScheduleData({ isNoneImagingDocs: value });
    }
  };

  const handleOnDeleteImagingDocsPage = (docId) => {
    setImagingDocs((prvState) => prvState.filter(el => el.id !== docId));
  };

  const handleOnDeleteImagingDocsDocument = () => {
    setImagingDocs([]);
  };

  const handleOnConsultsDocsUploaded = (docs) => {
    setConsultsDocs(docs);
  };

  const handleOnChangeIsNoneConsultsDocs = (value) => {
    setIsNoneConsults(value);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isNoneConsults: value });
    } else {
      props.updateNewCaseScheduleData({ isNoneConsults: value });
    }
  };

  const handleOnDeleteConsultsDocsPage = (docId) => {
    setConsultsDocs((prvState) => prvState.filter(el => el.id !== docId));
  };

  const handleOnDeleteConsultsDocsDocument = () => {
    setConsultsDocs([]);
  };

  const handleOnNursingDocsUploaded = (docs) => {
    setNursingDocs(docs);
  };

  const handleOnChangeIsNoneNursingDocs = (value) => {
    setIsNoneNursingDocs(value);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isNoneNursing: value });
    } else {
      props.updateNewCaseScheduleData({ isNoneNursing: value });
    }
  };

  const handleOnDeleteNursingDocsPage = (docId) => {
    setNursingDocs((prvState) => prvState.filter(el => el.id !== docId));
  };

  const handleOnDeleteNursingDocsDocument = () => {
    setNursingDocs([]);
  };

  const handleOnSurgeonDocsUploaded = (docs) => {
    setSurgeonDocs(docs);
  };

  const handleOnChangeIsNoneSurgeonDocs = (value) => {
    setIsNoneSurgeonDocs(value);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isNoneSurgeon: value });
    } else {
      props.updateNewCaseScheduleData({ isNoneSurgeon: value });
    }
  };

  const handleOnDeleteSurgeonDocsPage = (docId) => {
    setSurgeonDocs((prvState) => prvState.filter(el => el.id !== docId));
  };

  const handleOnDeleteSurgeonDocsDocument = (docId) => {
    setSurgeonDocs([]);
  };

  const handleOnDischargeDocsUploaded = (docs) => {
    setDischargeDocs(docs);
  };

  const handleOnChangeIsNoneDischarge = (value) => {
    setIsNoneDischargeDocs(value);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isNoneDischargeDocs: value });
    } else {
      props.updateNewCaseScheduleData({ isNoneDischargeDocs: value });
    }
  };

  const handleOnDeleteDischargeDocPage = (docId) => {
    setDischargeDocs(prvState => prvState.filter(el => el.id !== docId));
  };

  const handleOnDeleteDischargeDocDocument = () => {
    setDischargeDocs([]);
  };

  const handleOnOrdersPreOpFormDocsUploaded = (docs) => {
    setOrdersPreOpDocs(docs);
  };

  const handleOnChangeIsNoneOrdersPreOpForm = (value) => {
    setIsNoneOrdersPreOpDocs(value);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isNoneOrdersPreOpDocs: value });
    } else {
      props.updateNewCaseScheduleData({ isNoneOrdersPreOpDocs: value });
    }
  };

  const handleOnDeleteOrdersPreOpFormmDocPage = (docId) => {
    setOrdersPreOpDocs((prvState) => prvState.filter(el => el.id !== docId));
  };

  const handleOnDeleteOrdersPreOpFormmDocDocument = () => {
    setOrdersPreOpDocs([]);
  };

  const handleOnOrdersIntraOpFormDocsUploaded = (docs) => {
    setOrdersIntraOpDocs(docs);
  };

  const handleOnChangeIsNoneOrdersIntraOpForm = (value) => {
    setIsNoneOrdersIntraOpDocs(value);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isNoneOrdersIntraOpDocs: value });
    } else {
      props.updateNewCaseScheduleData({ isNoneOrdersIntraOpDocs: value });
    }
  };

  const handleOnDeleteOrdersIntraOpFormmDocPage = (docId) => {
    setOrdersIntraOpDocs((prvState) => prvState.filter(el => el.id !== docId));
  };

  const handleOnDeleteOrdersIntraOpFormmDocDocument = (docId) => {
    setOrdersIntraOpDocs([]);
  };

  const handleOnOrdersPostOpFormDocsUploaded = (docs) => {
    setOrdresPostOpDocs(docs);
  };

  const handleOnChangeIsNoneOrdersPostOpForm = (value) => {
    setIsNoneOrdersPostOpDocs(value);
    if (props.forCaseBlocks) {
      props.updateCaseBlockActiveCaseSchedule({ isNoneOrdersPostOpDocs: value });
    } else {
      props.updateNewCaseScheduleData({ isNoneOrdersPostOpDocs: value });
    }
  };

  const handleOnDeleteOrdersPostOpFormmDocPage = (docId) => {
    setOrdresPostOpDocs((prvState) => prvState.filter(el => el.id !== docId));
  };

  const handleOnDeleteOrdersPostOpFormmDocDocument = () => {
    setOrdresPostOpDocs([]);
  };

  // --- Docs common event handlers
  const handleOnEditDocs = (data) => {
    console.log('Not required here...');
  };

  const handleOnScanDocs = (data) => {
    setNewCaseScannedDocs(clone(data));
    setShowCameraDrawer(true);
  };

  const handleOnShowCropper = (data) => {
    setCropperDocs(clone(data));
    setShowCropperDrawer(true);
  };

  const handleOnShowCamera = (data) => {
    setNewCaseScannedDocs(clone(data));
    setShowCameraDrawer(true);
  };

  // --- Cam Drawer Event-handlers
  const handleOnCloseCameraDrawer = () => {
    setNewCaseScannedDocs({});
    setShowCameraDrawer(false);
    setShowCamInspectorDrawer(false);
  };

  const handleOnScanCameraDrawer = (imageDataUrl) => {
    const imageExtension = findFileExtensionByMimeType(findBase64ImageMimeType(imageDataUrl));
    let updatedCaseDocs = clone(newCaseScannedDocs.caseDocs);
    const newDocId = Math.random().toString(36).slice(2);
    const newFileName = `file_${Math.random().toString(36).slice(2)}`;

    updatedCaseDocs = updatedCaseDocs.concat({
      id: newDocId,
      imageUrl: '',
      fileName: `${newFileName}${imageExtension}`,
      compositeImage: imageDataUrl
    });

    // Update scan document data object
    setNewCaseScannedDocs((prvState) => {
      return {
        ...prvState,
        caseDocs: updatedCaseDocs,
        selectedPageId: newDocId,
        newImageUrl: imageDataUrl
      };
    });

    // Hide camera drawer and show CamInspectorDrawer
    setShowCameraDrawer(false);
    setShowCamInspectorDrawer(true);
  };

  // --- Cam Inspector Drawer Event-handlers
  const handleOnCancelScanDocs = () => {
    setShowCameraDrawer(false);
    setShowCamInspectorDrawer(false);
    setNewCaseScannedDocs({});
  };

  const handleOnRetakeScanDocs = () => {
    switch (newCaseScannedDocs.formType) {
      case FORM_TYPE.faceSheet:
        setNewCaseScannedDocs((prvState) => ({
          ...prvState,
          caseDocs: clone(faceSheetDocs)
        }));
        break;
      case FORM_TYPE.recordsLabs:
        setNewCaseScannedDocs((prvState) => ({
          ...prvState,
          caseDocs: clone(labsDocs)
        }));
        break;
      case FORM_TYPE.recordsEkg:
        setNewCaseScannedDocs((prvState) => ({
          ...prvState,
          caseDocs: clone(ekgDocs)
        }));
        break;
      case FORM_TYPE.recordsImaging:
        setNewCaseScannedDocs((prvState) => ({
          ...prvState,
          caseDocs: clone(imagingDocs)
        }));
        break;
      case FORM_TYPE.recordsConsults:
        setNewCaseScannedDocs((prvState) => ({
          ...prvState,
          caseDocs: clone(consultsDocs)
        }));
        break;
      case FORM_TYPE.consentsSurgery:
        setNewCaseScannedDocs((prvState) => ({
          ...prvState,
          caseDocs: clone(consentSurgFormDocs)
        }));
        break;
      case FORM_TYPE.consentsAnesthesia:
        setNewCaseScannedDocs((prvState) => ({
          ...prvState,
          caseDocs: clone(consentFormDocs)
        }));
        break;
      case FORM_TYPE.nursing:
        setNewCaseScannedDocs((prvState) => ({
          ...prvState,
          caseDocs: clone(nursingDocs)
        }));
        break;
      case FORM_TYPE.surgeon:
        setNewCaseScannedDocs((prvState) => ({
          ...prvState,
          caseDocs: clone(surgeonDocs)
        }));
        break;
      case FORM_TYPE.anesthesiaPreOp:
        setNewCaseScannedDocs((prvState) => ({
          ...prvState,
          caseDocs: clone(preOpFormDocs)
        }));
        break;
      case FORM_TYPE.anesthesiaIntraOp:
        setNewCaseScannedDocs((prvState) => ({
          ...prvState,
          caseDocs: clone(intraOpFormDocs)
        }));
        break;
      case FORM_TYPE.anesthesiaPostOp:
        setNewCaseScannedDocs((prvState) => ({
          ...prvState,
          caseDocs: clone(postOpFormDocs)
        }));
        break;
      case FORM_TYPE.ordersPreOp:
        setNewCaseScannedDocs((prvState) => ({
          ...prvState,
          caseDocs: clone(ordersPreOpDocs)
        }));
        break;
      case FORM_TYPE.ordersIntraOp:
        setNewCaseScannedDocs((prvState) => ({
          ...prvState,
          caseDocs: clone(ordersIntraOpDocs)
        }));
        break;
      case FORM_TYPE.ordersPostOp:
        setNewCaseScannedDocs((prvState) => ({
          ...prvState,
          caseDocs: clone(ordresPostOpDocs)
        }));
        break;
      case FORM_TYPE.discharge:
        setNewCaseScannedDocs((prvState) => ({
          ...prvState,
          caseDocs: clone(dischargeDocs)
        }));
        break;
      default:
        console.log(`Not implemented for ${newCaseScannedDocs.formType}`);
    }
    setShowCameraDrawer(true);
    setShowCamInspectorDrawer(false);
  };

  const handleOnCloseScanDocs = () => {
    const updatedDocs = clone(newCaseScannedDocs.caseDocs);

    switch (newCaseScannedDocs.formType) {
      case FORM_TYPE.faceSheet:
        setFaceSheetDocs(updatedDocs);
        break;
      case FORM_TYPE.recordsLabs:
        setLabsDocs(updatedDocs);
        break;
      case FORM_TYPE.recordsEkg:
        setEkgDocs(updatedDocs);
        break;
      case FORM_TYPE.recordsImaging:
        setImagingDocs(updatedDocs);
        break;
      case FORM_TYPE.recordsConsults:
        setConsultsDocs(updatedDocs);
        break;
      case FORM_TYPE.consentsSurgery:
        setConsentSurgFormDocs(updatedDocs);
        break;
      case FORM_TYPE.consentsAnesthesia:
        setConsentFormDocs(updatedDocs);
        break;
      case FORM_TYPE.nursing:
        setNursingDocs(updatedDocs);
        break;
      case FORM_TYPE.surgeon:
        setSurgeonDocs(updatedDocs);
        break;
      case FORM_TYPE.anesthesiaPreOp:
        setPreOpFormDocs(updatedDocs);
        break;
      case FORM_TYPE.anesthesiaIntraOp:
        setIntraOpFormDocs(updatedDocs);
        break;
      case FORM_TYPE.anesthesiaPostOp:
        setPostOpFormDocs(updatedDocs);
        break;
      case FORM_TYPE.ordersPreOp:
        setOrdersPreOpDocs(updatedDocs);
        break;
      case FORM_TYPE.ordersIntraOp:
        setOrdersIntraOpDocs(updatedDocs);
        break;
      case FORM_TYPE.ordersPostOp:
        setOrdresPostOpDocs(updatedDocs);
        break;
      case FORM_TYPE.discharge:
        setDischargeDocs(updatedDocs);
        break;
      default:
        console.log(`Not implemented for ${newCaseScannedDocs.formType}`);
    }
    setShowCameraDrawer(false);
    setShowCamInspectorDrawer(false);
    setNewCaseScannedDocs({});
  };

  const handleOnCropperClose = (docs) => {
    const updatedCroppedDocs = clone(docs);

    switch (cropperDocs.formType) {
      case FORM_TYPE.faceSheet:
        setFaceSheetDocs(updatedCroppedDocs);
        break;
      case FORM_TYPE.recordsLabs:
        setLabsDocs(updatedCroppedDocs);
        break;
      case FORM_TYPE.recordsEkg:
        setEkgDocs(updatedCroppedDocs);
        break;
      case FORM_TYPE.recordsImaging:
        setImagingDocs(updatedCroppedDocs);
        break;
      case FORM_TYPE.recordsConsults:
        setConsultsDocs(updatedCroppedDocs);
        break;
      case FORM_TYPE.consentsSurgery:
        setConsentSurgFormDocs(updatedCroppedDocs);
        break;
      case FORM_TYPE.consentsAnesthesia:
        setConsentFormDocs(updatedCroppedDocs);
        break;
      case FORM_TYPE.nursing:
        setNursingDocs(updatedCroppedDocs);
        break;
      case FORM_TYPE.surgeon:
        setSurgeonDocs(updatedCroppedDocs);
        break;
      case FORM_TYPE.anesthesiaPreOp:
        setPreOpFormDocs(updatedCroppedDocs);
        break;
      case FORM_TYPE.anesthesiaIntraOp:
        setIntraOpFormDocs(updatedCroppedDocs);
        break;
      case FORM_TYPE.anesthesiaPostOp:
        setPostOpFormDocs(updatedCroppedDocs);
        break;
      case FORM_TYPE.ordersPreOp:
        setOrdersPreOpDocs(updatedCroppedDocs);
        break;
      case FORM_TYPE.ordersIntraOp:
        setOrdersIntraOpDocs(updatedCroppedDocs);
        break;
      case FORM_TYPE.ordersPostOp:
        setOrdresPostOpDocs(updatedCroppedDocs);
        break;
      case FORM_TYPE.discharge:
        setDischargeDocs(updatedCroppedDocs);
        break;
      default:
        console.log(`Not implemented for ${newCaseScannedDocs.formType}`);
    }

    setShowCropperDrawer(false);
    setCropperDocs({});
  };

  /* ___ MENU ITEMS _______________________________________________ */
  const procedureSearchItems = [];
  // Append search text
  if (anesthesiaProcedureValue.length > 0) {
    procedureSearchItems.push(
      <div
        key='88888999SurgProcedure'
        className={`fx fx__v-center ${css(styles.menuItem)}`}
        onClick={(e) => {
          e.stopPropagation();
          const tmpProc = {
            id: Math.random().toString(36).slice(2),
            text: anesthesiaProcedureValue,
            code: '',
            description: anesthesiaProcedureValue,
            npi: 0
          };
          setShowAnesthesiaProceduresSearchMenu(false);
          setAnesthesiaProcedureValue('');
          setAnesthesiaProcedures((prevState) => {
            return prevState.concat(tmpProc);
          });
        }}
      >
        <div className='ml-2'>
          <div style={{ height: '40px', display: 'flex', alignItems: 'center' }}>
            {anesthesiaProcedureValue}
          </div>
        </div>
      </div>
    );
  }
  if (anesthesiaProceduresSearchResults.length > 0) {
    // Append search results
    anesthesiaProceduresSearchResults.forEach((el) => {
      procedureSearchItems.push(
        <div
          key={el._id}
          className={`fx fx__v-center ${css(styles.menuItem)}`}
          onClick={(e) => {
            e.stopPropagation();
            ;
            setShowAnesthesiaProceduresSearchMenu(false);
            setAnesthesiaProcedureValue('');
            setAnesthesiaProcedures((prevState) => {
              if (prevState.findIndex(item => item.id === el._id) < 0) {
                return prevState.concat({
                  id: el._id,
                  text: `${el.description}`,
                  code: el.code,
                  description: `${el.description}`,
                  npi: el.npi
                });
              } else {
                return prevState;
              }
            });
          }}
        >
          <div className='ml-2'>
            <div style={{ height: '40px', display: 'flex', alignItems: 'center' }}>
              {getHighlightedText(el.description, anesthesiaProcedureValue)}
            </div>
          </div>
        </div>
      );
    });
  }

  /* ___ ACTIVE DRAWER COMPONENT _____________________________________ */
  let activeDrawerComponent = null;
  switch (drawerActiveTab) {
    case 'case':
      activeDrawerComponent = (
        <CaseTab
          forCaseBlocks={props.forCaseBlocks}
          onClose={closeScheduleCaseDrawer}
          onDataChange={handleOnCaseDataChange}
          showFooter={false}
        />
      );
      break;
    case 'patient':
      activeDrawerComponent = (
        <PatientTab
          onAddPatient={handleOnAddPatient}
          onDeletePatient={handleOnDeletePatient}
          onReloadPatientData={handleOnReloadPatientData}
        />
      );
      break;
    case 'payers':
      activeDrawerComponent = (
        <PayerTab
          patientData={
            props.forCaseBlocks
              ? props.caseBlockPatients[props.caseBlockActiveCaseSchedule.patientId]
              : props.newCaseSchedulePatient
          }
          onReloadPatientData={() => {
            if (props.forCaseBlocks) {
              props.reloadCaseBlockCasePatientData(props.caseBlockActiveCaseSchedule.patientId);
            } else {
              props.reloadCaseSchedulePatientData(props.newCaseSchedulePatient._id)
            }
          }}
        />
      );
      break;
    default:
      activeDrawerComponent = null;
  }

  /* ___ CASE DOCUMENTS ___________________________________________ */
  let activeDocComponent = null;
  switch (activeTab) {
    case TABS[0].text: // FaceSheet
      activeDocComponent = (
        <CaseDoc
          key='facesheet_docs'
          showFlag
          isNewCase
          formType={FORM_TYPE.faceSheet}
          flagType={FLAG_VALUE.warning}
          caseDocs={faceSheetDocs}
          isNone={isNoneFaceSheet}
          onChangeIsNone={handleOnChangeIsNoneFaceSheet}
          onCaseDocUploaded={handleOnFaceSheetDocsUploaded}
          onDeletePage={handleOnDeleteFaceSheetDocPage}
          onDeleteDocument={handleOnDeleteFaceSheetDocDocument}
          onEdit={handleOnEditDocs}
          onScanDocument={handleOnScanDocs}
          onShowCropper={handleOnShowCropper}
          onShowCamera={handleOnShowCamera}
        />
      );
      break;
    case TABS[1].text: // Records
      activeDocComponent = (
        <>
          <TabsContainer
            dropDownId="records_sub_tabs"
            showPlusIcon={false}
            isDrawer={false}
            shiftMethod='minWidth'
            minWidth={610}
            containerStyles={{ width: '100%' }}
          >
            {/* Labs */}
            <TabItem
              key='1199'
              tabKey='1199'
              parentKey='11999'
              text='Labs'
              isActive={recordsSubTab === 'labs'}
              showTabIcon
              showSvgIcon
              svgIcon={(() => {
                if (isNoneLabDocs) {
                  return IS_NONE_ICON;
                }
                if (labsDocs.length > 0) {
                  return SUCCESS_ICON;
                } else {
                  return BELL_ICON;
                }
              })()}
              style={{
                ...COMMON_TAB_ITEM_STYLES,
                width: window.innerWidth > 720 ? '110px' : '25%',
                minWidth: window.innerWidth > 720 ? '110px' : '25%',
                maxWidth: window.innerWidth > 720 ? '110px' : '25%',
                background: recordsSubTab === 'labs' ? '#184878' : '#083050'
              }}
              textStyles={TABS_TEXT_STYLES}
              onActivate={() => {
                setRecordsSubTab('labs');
              }}
            >
              Labs
            </TabItem>
            {/* EKG */}
            <TabItem
              key='12992001'
              tabKey='12992001'
              parentKey='12993000'
              text='EKG'
              isActive={recordsSubTab === 'ekg'}
              showTabIcon
              showSvgIcon
              svgIcon={(() => {
                if (isNoneEkgDocs) {
                  return <DocumentNoneIcon height={20} />;
                }
                if (ekgDocs.length > 0) {
                  return <DocumentSuccessIcon height={20} />;
                } else {
                  return <DocumentWarningIcon height={20} />;
                }
              })()}
              style={{
                ...COMMON_TAB_ITEM_STYLES,
                width: window.innerWidth > 720 ? '110px' : '25%',
                minWidth: window.innerWidth > 720 ? '110px' : '25%',
                maxWidth: window.innerWidth > 720 ? '110px' : '25%',
                background: recordsSubTab === 'ekg' ? '#184878' : '#083050'
              }}
              textStyles={TABS_TEXT_STYLES}
              onActivate={() => {
                setRecordsSubTab('ekg');
              }}
            >
              EKG
            </TabItem>
            {/* Imaging */}
            <TabItem
              key='19192002'
              tabKey='19192002'
              parentKey='19194000'
              text='PostOp'
              isActive={recordsSubTab === 'imaging'}
              showTabIcon
              showSvgIcon
              svgIcon={(() => {
                if (isNoneImagingDocs) {
                  return <DocumentNoneIcon height={20} />;
                }
                if (imagingDocs.length > 0) {
                  return <DocumentSuccessIcon height={20} />;
                } else {
                  return <DocumentWarningIcon height={20} />;
                }
              })()}
              style={{
                ...COMMON_TAB_ITEM_STYLES,
                width: window.innerWidth > 720 ? '110px' : '25%',
                minWidth: window.innerWidth > 720 ? '110px' : '25%',
                maxWidth: window.innerWidth > 720 ? '110px' : '25%',
                background: recordsSubTab === 'imaging' ? '#184878' : '#083050'
              }}
              textStyles={TABS_TEXT_STYLES}
              onActivate={() => {
                setRecordsSubTab('imaging');
              }}
            >
              Imaging
            </TabItem>
            {/* Consults */}
            <TabItem
              key='2003'
              tabKey='2003'
              parentKey='5000'
              text='Procedures'
              isActive={recordsSubTab === 'consults'}
              showTabIcon
              showSvgIcon
              svgIcon={(() => {
                if (isNoneConsults) {
                  return <DocumentNoneIcon height={20} />;
                }
                if (consultsDocs.length > 0) {
                  return <DocumentSuccessIcon height={20} />;
                } else {
                  return <DocumentWarningIcon height={20} />;
                }
              })()}
              style={{
                ...COMMON_TAB_ITEM_STYLES,
                width: window.innerWidth > 720 ? '110px' : '25%',
                minWidth: window.innerWidth > 720 ? '110px' : '25%',
                maxWidth: window.innerWidth > 720 ? '110px' : '25%',
                background: recordsSubTab === 'consults' ? '#184878' : '#083050'
              }}
              textStyles={TABS_TEXT_STYLES}
              onActivate={() => {
                setRecordsSubTab('consults');
              }}
            >
              Consults
            </TabItem>
          </TabsContainer>
          <div className={css(styles.pdfDocContainer)}>
            {recordsSubTab === 'labs' &&
              <CaseDoc
                key='records_labs_docs'
                showFlag
                isNewCase
                formType={FORM_TYPE.recordsLabs}
                flagType={FLAG_VALUE.warning}
                caseDocs={labsDocs}
                isNone={isNoneLabDocs}
                onChangeIsNone={handleOnChangeIsNoneLabsDocs}
                onCaseDocUploaded={handleOnLabsDocsUploaded}
                onDeletePage={handleOnDeleteLabsDocsPage}
                onDeleteDocument={handleOnDeleteLabsDocsDocument}
                onEdit={handleOnEditDocs}
                onScanDocument={handleOnScanDocs}
                onShowCropper={handleOnShowCropper}
                onShowCamera={handleOnShowCamera}
              />
            }
            {recordsSubTab === 'ekg' &&
              <CaseDoc
                key='records_ekg_docs'
                showFlag
                isNewCase
                formType={FORM_TYPE.recordsEkg}
                flagType={FLAG_VALUE.warning}
                caseDocs={ekgDocs}
                isNone={isNoneEkgDocs}
                onChangeIsNone={handleOnChangeIsNoneEkgDocs}
                onCaseDocUploaded={handleOnEkgDocsUploaded}
                onDeletePage={handleOnDeleteEkgDocsPage}
                onDeleteDocument={handleOnDeleteEkgDocsDocument}
                onEdit={handleOnEditDocs}
                onScanDocument={handleOnScanDocs}
                onShowCropper={handleOnShowCropper}
                onShowCamera={handleOnShowCamera}
              />
            }
            {recordsSubTab === 'imaging' &&
              <CaseDoc
                key='records_imaging_docs'
                showFlag
                isNewCase
                formType={FORM_TYPE.recordsImaging}
                flagType={FLAG_VALUE.warning}
                caseDocs={imagingDocs}
                isNone={isNoneImagingDocs}
                onChangeIsNone={handleOnChangeIsNoneImagingDocs}
                onCaseDocUploaded={handleOnImagingDocsUploaded}
                onDeletePage={handleOnDeleteImagingDocsPage}
                onDeleteDocument={handleOnDeleteImagingDocsDocument}
                onEdit={handleOnEditDocs}
                onScanDocument={handleOnScanDocs}
                onShowCropper={handleOnShowCropper}
                onShowCamera={handleOnShowCamera}
              />
            }
            {recordsSubTab === 'consults' &&
              <CaseDoc
                key='records_consults_docs'
                showFlag
                isNewCase
                formType={FORM_TYPE.recordsConsults}
                flagType={FLAG_VALUE.warning}
                caseDocs={consultsDocs}
                isNone={isNoneConsults}
                onChangeIsNone={handleOnChangeIsNoneConsultsDocs}
                onCaseDocUploaded={handleOnConsultsDocsUploaded}
                onDeletePage={handleOnDeleteConsultsDocsPage}
                onDeleteDocument={handleOnDeleteConsultsDocsDocument}
                onEdit={handleOnEditDocs}
                onScanDocument={handleOnScanDocs}
                onShowCropper={handleOnShowCropper}
                onShowCamera={handleOnShowCamera}
              />
            }
          </div>
        </>
      );
      break;
    case TABS[2].text: // Consent Forms
      activeDocComponent = (
        <>
          <TabsContainer
            dropDownId="consent_forms_sub_tabs"
            showPlusIcon={false}
            isDrawer={false}
            shiftMethod='minWidth'
            minWidth={610}
            containerStyles={{ width: '100%' }}
          >
            {/* Consents - Surgery sub tab */}
            <TabItem
              key='2334'
              tabKey='2334'
              parentKey='1223'
              text='Surgery'
              isActive={consentActiveTab === 'surgery'}
              showTabIcon
              showSvgIcon
              svgIcon={(() => {
                if (isNoneConsentSurgFormDocs) {
                  return <DocumentNoneIcon height={20} />;
                }
                if (consentSurgFormDocs.length > 0) {
                  return <DocumentSuccessIcon height={20} />;
                } else {
                  return <DocumentWarningIcon height={20} />;
                }
              })()}
              style={{
                ...COMMON_TAB_ITEM_STYLES,
                width: '110px',
                minWidth: '110px',
                maxWidth: '110px',
                background: consentActiveTab === 'surgery' ? '#184878' : '#083050'
              }}
              textStyles={TABS_TEXT_STYLES}
              onActivate={() => {
                setConsentActiveTab('surgery');
              }}
            >
              Surgery
            </TabItem>
            {/* Consents - Anesthesia sub tab */}
            <TabItem
              key='2333'
              tabKey='2333'
              parentKey='1222'
              text='Anesthesia'
              isActive={consentActiveTab === 'anesthesia'}
              showTabIcon
              showSvgIcon
              svgIcon={(() => {
                if (isNoneConsentFormDocs) {
                  return <DocumentNoneIcon height={20} />;
                }
                if (consentFormDocs.length > 0) {
                  return <DocumentSuccessIcon height={20} />;
                } else {
                  return <DocumentWarningIcon height={20} />;
                }
              })()}
              style={{
                ...COMMON_TAB_ITEM_STYLES,
                width: '110px',
                minWidth: '110px',
                maxWidth: '110px',
                background: consentActiveTab === 'anesthesia' ? '#184878' : '#083050'
              }}
              textStyles={TABS_TEXT_STYLES}
              onActivate={() => {
                setConsentActiveTab('anesthesia');
              }}
            >
              Anesthesia
            </TabItem>
          </TabsContainer>
          <div className={css(styles.pdfDocContainer)}>
            {consentActiveTab === 'surgery' &&
              <CaseDoc
                key='consent_surgery_docs'
                showFlag
                isNewCase
                formType={FORM_TYPE.consentSurgFormDocs}
                flagType={FLAG_VALUE.warning}
                caseDocs={consentSurgFormDocs}
                isNone={isNoneConsentSurgFormDocs}
                onChangeIsNone={handleOnChangeIsNoneConsentSurgForm}
                onCaseDocUploaded={handleOnConsentSurgFormDocsUploaded}
                onDeletePage={handleOnDeleteConsentSurgFormDocPage}
                onDeleteDocument={handleOnDeleteConsentSurgFormDocDocument}
                onEdit={handleOnEditDocs}
                onScanDocument={handleOnScanDocs}
                onShowCropper={handleOnShowCropper}
                onShowCamera={handleOnShowCamera}
              />
            }
            {consentActiveTab === 'anesthesia' &&
              <CaseDoc
                key='consent_anesthesia_docs'
                showFlag
                isNewCase
                formType={FORM_TYPE.consentsAnesthesia}
                flagType={FLAG_VALUE.warning}
                caseDocs={consentFormDocs}
                isNone={isNoneConsentFormDocs}
                onChangeIsNone={handleOnChangeIsNoneConsentForm}
                onCaseDocUploaded={handleOnConsentFormDocsUploaded}
                onDeletePage={handleOnDeleteConsentFormDocPage}
                onDeleteDocument={handleOnDeleteConsentFormDocDocument}
                onEdit={handleOnEditDocs}
                onScanDocument={handleOnScanDocs}
                onShowCropper={handleOnShowCropper}
                onShowCamera={handleOnShowCamera}
              />
            }
          </div>
        </>
      );
      break;
    case TABS[3].text: // Nursing
      activeDocComponent = (
        <CaseDoc
          key='nursing_docs'
          showFlag
          isNewCase
          formType={FORM_TYPE.nursing}
          flagType={FLAG_VALUE.warning}
          caseDocs={nursingDocs}
          isNone={isNoneNursingDocs}
          onChangeIsNone={handleOnChangeIsNoneNursingDocs}
          onCaseDocUploaded={handleOnNursingDocsUploaded}
          onDeletePage={handleOnDeleteNursingDocsPage}
          onDeleteDocument={handleOnDeleteNursingDocsDocument}
          onEdit={handleOnEditDocs}
          onScanDocument={handleOnScanDocs}
          onShowCropper={handleOnShowCropper}
          onShowCamera={handleOnShowCamera}
        />
      );
      break;
    case TABS[4].text: // Surgeon
      activeDocComponent = (
        <CaseDoc
          key='consent_anesthesia_docs'
          showFlag
          isNewCase
          formType={FORM_TYPE.consentsAnesthesia}
          flagType={FLAG_VALUE.warning}
          caseDocs={surgeonDocs}
          isNone={isNoneSurgeonDocs}
          onChangeIsNone={handleOnChangeIsNoneSurgeonDocs}
          onCaseDocUploaded={handleOnSurgeonDocsUploaded}
          onDeletePage={handleOnDeleteSurgeonDocsPage}
          onDeleteDocument={handleOnDeleteSurgeonDocsDocument}
          onEdit={handleOnEditDocs}
          onScanDocument={handleOnScanDocs}
          onShowCropper={handleOnShowCropper}
          onShowCamera={handleOnShowCamera}
        />
      );
      break;
    case TABS[5].text: // Anesthesia Forms
      activeDocComponent = (
        <>
          <TabsContainer
            dropDownId="anesthesia_forms_sub_tabs"
            showPlusIcon={false}
            isDrawer={false}
            shiftMethod='minWidth'
            minWidth={610}
            containerStyles={{ width: '100%' }}
          >
            {/* PreOp Tab */}
            <TabItem
              key='2000'
              tabKey='2000'
              parentKey='2000'
              text='PreOp'
              isActive={anesthesiaSubTab === 'preOp'}
              showTabIcon
              showSvgIcon
              // svgIcon={(preOpFormDocs.length > 0 || isNonePreOpFormDocs) ? SUCCESS_ICON : BELL_ICON}
              svgIcon={(() => {
                if (isNonePreOpFormDocs) {
                  return <DocumentNoneIcon height={20} />;
                }
                if (preOpFormDocs.length > 0) {
                  return <DocumentSuccessIcon height={20} />;
                } else {
                  return <DocumentWarningIcon height={20} />;
                }
              })()}
              style={{
                ...COMMON_TAB_ITEM_STYLES,
                width: window.innerWidth > 720 ? '110px' : '22%',
                minWidth: window.innerWidth > 720 ? '110px' : '22%',
                maxWidth: window.innerWidth > 720 ? '110px' : '22%',
                background: anesthesiaSubTab === 'preOp' ? '#184878' : '#083050'
              }}
              textStyles={TABS_TEXT_STYLES}
              onActivate={() => {
                setAnesthesiaSubTab('preOp');
              }}
            >
              PreOp
            </TabItem>
            {/* IntraOp Tab */}
            <TabItem
              key='2001'
              tabKey='2001'
              parentKey='3000'
              text='IntraOp'
              isActive={anesthesiaSubTab === 'intraOp'}
              showTabIcon
              showSvgIcon
              // svgIcon={(intraOpFormDocs.length > 0 || isNoneIntraOpFormDocs) ? SUCCESS_ICON : BELL_ICON}
              svgIcon={(() => {
                if (isNoneIntraOpFormDocs) {
                  return <DocumentNoneIcon height={20} />;
                }
                if (intraOpFormDocs.length > 0) {
                  return <DocumentSuccessIcon height={20} />;
                } else {
                  return <DocumentWarningIcon height={20} />;
                }
              })()}
              style={{
                ...COMMON_TAB_ITEM_STYLES,
                width: window.innerWidth > 720 ? '110px' : '25%',
                minWidth: window.innerWidth > 720 ? '110px' : '25%',
                maxWidth: window.innerWidth > 720 ? '110px' : '25%',
                background: anesthesiaSubTab === 'intraOp' ? '#184878' : '#083050'
              }}
              textStyles={TABS_TEXT_STYLES}
              onActivate={() => {
                setAnesthesiaSubTab('intraOp');
              }}
            >
              IntraOp
            </TabItem>
            {/* PostOp */}
            <TabItem
              key='2002'
              tabKey='2002'
              parentKey='4000'
              text='PostOp'
              isActive={anesthesiaSubTab === 'postOp'}
              showTabIcon
              showSvgIcon
              // svgIcon={(postOpFormDocs.length > 0 || isNonePostOpFormDocs) ? SUCCESS_ICON : BELL_ICON}
              svgIcon={(() => {
                if (isNonePostOpFormDocs) {
                  return <DocumentNoneIcon height={20} />;
                }
                if (postOpFormDocs.length > 0) {
                  return <DocumentSuccessIcon height={20} />;
                } else {
                  return <DocumentWarningIcon height={20} />;
                }
              })()}
              style={{
                ...COMMON_TAB_ITEM_STYLES,
                width: window.innerWidth > 720 ? '110px' : '25%',
                minWidth: window.innerWidth > 720 ? '110px' : '25%',
                maxWidth: window.innerWidth > 720 ? '110px' : '25%',
                background: anesthesiaSubTab === 'postOp' ? '#184878' : '#083050'
              }}
              textStyles={TABS_TEXT_STYLES}
              onActivate={() => {
                setAnesthesiaSubTab('postOp');
              }}
            >
              PostOp
            </TabItem>
            {/* Procedures */}
            <TabItem
              key='2003'
              tabKey='2003'
              parentKey='5000'
              text='Procedures'
              isActive={anesthesiaSubTab === 'procedures'}
              showTabIcon
              showSvgIcon
              svgIcon={(() => {
                if (isNoneAnesthesiaProcedure) {
                  return <DocumentNoneIcon />;
                }
                if (anesthesiaProcedures.length === 0) {
                  return <DocumentWarningIcon height={20} />;
                } else if (anesthesiaProcedures.length > 0 && (anesthesiaProcedures.filter(el => el.npi === 0)).length > 0) {
                  return <DocumentWarningIcon height={20} />;
                } else {
                  return <DocumentSuccessIcon height={20} />;
                }
              })()}
              style={{
                ...COMMON_TAB_ITEM_STYLES,
                width: window.innerWidth > 720 ? '110px' : '28%',
                minWidth: window.innerWidth > 720 ? '110px' : '28%',
                maxWidth: window.innerWidth > 720 ? '110px' : '28%',
                background: anesthesiaSubTab === 'procedures' ? '#184878' : '#083050'
              }}
              textStyles={TABS_TEXT_STYLES}
              onActivate={() => {
                setAnesthesiaSubTab('procedures');
              }}
            >
              Procedures
            </TabItem>
          </TabsContainer>
          <div className={css(styles.pdfDocContainer)}>
            {anesthesiaSubTab === 'preOp' &&
              <CaseDoc
                key='anesthesia_preop_docs'
                showFlag
                isNewCase
                formType={FORM_TYPE.anesthesiaPreOp}
                flagType={FLAG_VALUE.warning}
                caseDocs={preOpFormDocs}
                isNone={isNonePreOpFormDocs}
                onChangeIsNone={handleOnChangeIsNonePreOpForm}
                onCaseDocUploaded={handleOnPreOpFormDocsUploaded}
                onDeletePage={handleOnDeletePreOpFormmDocPage}
                onDeleteDocument={handleOnDeletePreOpFormmDocDocument}
                onEdit={handleOnEditDocs}
                onScanDocument={handleOnScanDocs}
                onShowCropper={handleOnShowCropper}
                onShowCamera={handleOnShowCamera}
              />
            }
            {anesthesiaSubTab === 'intraOp' &&
              <CaseDoc
                key='anesthesia_intraop_docs'
                showFlag
                isNewCase
                formType={FORM_TYPE.anesthesiaIntraOp}
                flagType={FLAG_VALUE.warning}
                caseDocs={intraOpFormDocs}
                isNone={isNoneIntraOpFormDocs}
                onChangeIsNone={handleOnChangeIsNoneIntraOpForm}
                onCaseDocUploaded={handleOnIntraOpFormDocsUploaded}
                onDeletePage={handleOnDeleteIntraOpFormmDocPage}
                onDeleteDocument={handleOnDeleteIntraOpFormmDocDocument}
                onEdit={handleOnEditDocs}
                onScanDocument={handleOnScanDocs}
                onShowCropper={handleOnShowCropper}
                onShowCamera={handleOnShowCamera}
              />
            }
            {anesthesiaSubTab === 'postOp' &&
              <CaseDoc
                key='anesthesia_postop_docs'
                showFlag
                isNewCase
                formType={FORM_TYPE.anesthesiaPostOp}
                flagType={FLAG_VALUE.warning}
                caseDocs={postOpFormDocs}
                isNone={isNonePostOpFormDocs}
                onChangeIsNone={handleOnChangeIsNonePostOpForm}
                onCaseDocUploaded={handleOnPostOpFormDocsUploaded}
                onDeletePage={handleOnDeletePostOpFormmDocPage}
                onDeleteDocument={handleOnDeletePostOpFormmDocDocument}
                onEdit={handleOnEditDocs}
                onScanDocument={handleOnScanDocs}
                onShowCropper={handleOnShowCropper}
                onShowCamera={handleOnShowCamera}
              />
            }
            {anesthesiaSubTab === 'procedures' &&
              <div
                className='m-2'
                style={{ width: `${DRAWER_WIDTH}px` }}
              >
                <div
                  className='mt-4 mb-2 fx fx__v-center'
                  style={{
                    width: '355px',
                    justifyContent: 'space-between'
                  }}
                >
                  <CaseField
                    heading='Anesthesia Procedures'
                    showAlert={false}
                    showNoneFlag={isNoneAnesthesiaProcedure}
                    showIncomplete={(() => {
                      if (!isNoneAnesthesiaProcedure) {
                        if (anesthesiaProcedures.length === 0) {
                          return true;
                        } else if (anesthesiaProcedures.length > 0 && (anesthesiaProcedures.filter(el => el.npi === 0)).length > 0) {
                          return true;
                        } else {
                          return false;
                        }
                      }
                    })()}
                    // showIncomplete={proceduresList.length === 0}
                    showPlusIcon={false}
                    className='ml-1'
                  />
                  <Checkbox
                    text='None'
                    isChecked={isNoneAnesthesiaProcedure}
                    onChange={() => {
                      // Note:
                      // As state update can before calling props.updateNewCaseScheduleData,
                      // so isNoneAnesthesiaProcedure value is extracted before pushing state update.
                      const value = isNoneAnesthesiaProcedure;
                      setIsNoneAnesthesiaProcedure(!value);
                      if (props.forCaseBlocks) {
                        props.updateCaseBlockActiveCaseSchedule({ isNoneAnesthesiaProcedure: !value });
                      } else {
                        props.updateNewCaseScheduleData({ isNoneAnesthesiaProcedure: !value });
                      }
                    }}
                  />
                </div>
                {/* Anesthesia procedure value textbox & search menu */}
                <div
                  ref={procedureSearchMenuRef}
                  className='mt-0'
                  style={{
                    // border: `1px solid ${blue[700]}`,
                    borderRadius: '4px',
                    position: 'relative'
                  }}
                >
                  <TextInput
                    value={anesthesiaProcedureValue}
                    placeholder="Search Anesthesia Procedure(s)"
                    disabled={isNoneAnesthesiaProcedure}
                    style={{
                      width: `${DRAWER_WIDTH}px`,
                      fontSize: '14px',
                      padding: '0 4px',
                      color: blue[200],
                      borderRadius: '4px'
                    }}
                    onChange={(e) => {
                      const { value } = e.target;
                      setAnesthesiaProcedureValue(value);
                    }}
                  />
                  {showAnesthesiaProceduresSearchMenu &&
                    <PopupMenu
                      top={35}
                      left={0}
                      zIndex='1550'
                      position="absolute"
                      visible={showAnesthesiaProceduresSearchMenu}
                      parent={procedureSearchMenuRef}
                      onOutsideClick={() => { setShowAnesthesiaProceduresSearchMenu(false); }}
                    >
                      <div className={css(styles.searchPopupMenuContainer)}>
                        {procedureSearchItems.length > 0 &&
                          <div className={`pl-2 fx fx__v-center ${css(styles.suggResults)}`}>
                            Suggested Results
                          </div>
                        }
                        {procedureSearchItems}
                      </div>
                    </PopupMenu>
                  }
                </div>
                {/* Surgical Procedures Cards */}
                {anesthesiaProcedures.map(dx => {
                  return (
                    <CaseUserCard
                      className='mt-1'
                      avatarImageUrl={null}
                      showCloseIcon
                      noAvatar
                      key={dx.id || dx._id}
                      dataId={dx.id || dx._id}
                      onClose={(id) => {
                        setAnesthesiaProcedures((prevState) => {
                          return prevState.filter((el) => {
                            if (el.id) {
                              return el.id !== id;
                            }
                            return el._id !== id;
                          });
                        });
                      }}
                    >
                      <div style={{ fontSize: '12px', marginLeft: '8px' }}>
                        <div>
                          {dx.description}

                        </div>
                      </div>
                    </CaseUserCard>
                  );
                })}
              </div>
            }
          </div>
        </>
      );
      break;
    case TABS[6].text: // Orders
      activeDocComponent = (
        <>
          <TabsContainer
            dropDownId="orders_forms_sub_tabs"
            showPlusIcon={false}
            isDrawer={false}
            shiftMethod='minWidth'
            minWidth={610}
            containerStyles={{ width: '100%' }}
          >
            {/* Orders - PreOp Tab */}
            <TabItem
              key='2000334'
              tabKey='2000334'
              parentKey='2000334'
              text='PreOp'
              isActive={ordersSubTab === 'preOp'}
              showTabIcon
              showSvgIcon
              svgIcon={(() => {
                if (isNoneOrdersPreOpDocs) {
                  return <DocumentNoneIcon height={20} />;
                }
                if (ordersPreOpDocs.length > 0) {
                  return <DocumentSuccessIcon height={20} />;
                } else {
                  return <DocumentWarningIcon height={20} />;
                }
              })()}
              style={{
                ...COMMON_TAB_ITEM_STYLES,
                width: '110px',
                minWidth: '110px',
                maxWidth: '110px',
                background: ordersSubTab === 'preOp' ? '#184878' : '#083050'
              }}
              textStyles={TABS_TEXT_STYLES}
              onActivate={() => {
                setOrdersSubTab('preOp');
              }}
            >
              PreOp
            </TabItem>
            {/* IntraOp Tab */}
            <TabItem
              key='2001334'
              tabKey='2001334'
              parentKey='3000334'
              text='IntraOp'
              isActive={ordersSubTab === 'intraOp'}
              showTabIcon
              showSvgIcon
              // svgIcon={(intraOpFormDocs.length > 0 || isNoneIntraOpFormDocs) ? SUCCESS_ICON : BELL_ICON}
              svgIcon={(() => {
                if (isNoneOrdersIntraOpDocs) {
                  return <DocumentNoneIcon height={20} />;
                }
                if (ordersIntraOpDocs.length > 0) {
                  return <DocumentSuccessIcon height={20} />;
                } else {
                  return <DocumentWarningIcon height={20} />;
                }
              })()}
              style={{
                ...COMMON_TAB_ITEM_STYLES,
                width: '110px',
                minWidth: '110px',
                maxWidth: '110px',
                background: ordersSubTab === 'intraOp' ? '#184878' : '#083050'
              }}
              textStyles={TABS_TEXT_STYLES}
              onActivate={() => {
                setOrdersSubTab('intraOp');
              }}
            >
              IntraOp
            </TabItem>
            {/* PostOp */}
            <TabItem
              key='2002'
              tabKey='2002'
              parentKey='4000'
              text='PostOp'
              isActive={ordersSubTab === 'postOp'}
              showTabIcon
              showSvgIcon
              // svgIcon={(postOpFormDocs.length > 0 || isNonePostOpFormDocs) ? SUCCESS_ICON : BELL_ICON}
              svgIcon={(() => {
                if (isNoneOrdersPostOpDocs) {
                  return <DocumentNoneIcon height={20} />;
                }
                if (ordresPostOpDocs.length > 0) {
                  return <DocumentSuccessIcon height={20} />;
                } else {
                  return <DocumentWarningIcon height={20} />;
                }
              })()}
              style={{
                ...COMMON_TAB_ITEM_STYLES,
                width: '110px',
                minWidth: '110px',
                maxWidth: '110px',
                background: ordersSubTab === 'postOp' ? '#184878' : '#083050'
              }}
              textStyles={TABS_TEXT_STYLES}
              onActivate={() => {
                setOrdersSubTab('postOp');
              }}
            >
              PostOp
            </TabItem>
          </TabsContainer>
          <div className={css(styles.pdfDocContainer)}>
            {ordersSubTab === 'preOp' &&
              <CaseDoc
                key='orders_preop_docs'
                showFlag
                isNewCase
                formType={FORM_TYPE.ordersPreOp}
                caseDocs={ordersPreOpDocs}
                isNone={isNoneOrdersPreOpDocs}
                flagType={FLAG_VALUE.warning}
                onChangeIsNone={handleOnChangeIsNoneOrdersPreOpForm}
                onCaseDocUploaded={handleOnOrdersPreOpFormDocsUploaded}
                onDeletePage={handleOnDeleteOrdersPreOpFormmDocPage}
                onDeleteDocument={handleOnDeleteOrdersPreOpFormmDocDocument}
                onEdit={handleOnEditDocs}
                onScanDocument={handleOnScanDocs}
                onShowCropper={handleOnShowCropper}
                onShowCamera={handleOnShowCamera}
              />
            }
            {ordersSubTab === 'intraOp' &&
              <CaseDoc
                key='orders_intraop_docs'
                showFlag
                isNewCase
                formType={FORM_TYPE.ordersIntraOp}
                flagType={FLAG_VALUE.warning}
                caseDocs={ordersIntraOpDocs}
                isNone={isNoneOrdersIntraOpDocs}
                onChangeIsNone={handleOnChangeIsNoneOrdersIntraOpForm}
                onCaseDocUploaded={handleOnOrdersIntraOpFormDocsUploaded}
                onDeletePage={handleOnDeleteOrdersIntraOpFormmDocPage}
                onDeleteDocument={handleOnDeleteOrdersIntraOpFormmDocDocument}
                onEdit={handleOnEditDocs}
                onScanDocument={handleOnScanDocs}
                onShowCropper={handleOnShowCropper}
                onShowCamera={handleOnShowCamera}
              />
            }
            {ordersSubTab === 'postOp' &&
              <CaseDoc
                key='orders_postop_docs'
                showFlag
                isNewCase
                formType={FORM_TYPE.ordersPostOp}
                flagType={FLAG_VALUE.warning}
                caseDocs={ordresPostOpDocs}
                isNone={isNoneOrdersPostOpDocs}
                onChangeIsNone={handleOnChangeIsNoneOrdersPostOpForm}
                onCaseDocUploaded={handleOnOrdersPostOpFormDocsUploaded}
                onDeletePage={handleOnDeleteOrdersPostOpFormmDocPage}
                onDeleteDocument={handleOnDeleteOrdersPostOpFormmDocDocument}
                onEdit={handleOnEditDocs}
                onScanDocument={handleOnScanDocs}
                onShowCropper={handleOnShowCropper}
                onShowCamera={handleOnShowCamera}
              />
            }
          </div>
        </>
      );
      break;
    case TABS[7].text: // Discharge
      activeDocComponent = (
        <CaseDoc
          key='discharge_docs'
          showFlag
          isNewCase
          formType={FORM_TYPE.discharge}
          caseDocs={dischargeDocs}
          isNone={isNoneDischargeDocs}
          flagType={FLAG_VALUE.warning}
          onChangeIsNone={handleOnChangeIsNoneDischarge}
          onCaseDocUploaded={handleOnDischargeDocsUploaded}
          onDeletePage={handleOnDeleteDischargeDocPage}
          onDeleteDocument={handleOnDeleteDischargeDocDocument}
          onEdit={handleOnEditDocs}
          onScanDocument={handleOnScanDocs}
          onShowCropper={handleOnShowCropper}
          onShowCamera={handleOnShowCamera}
        />
      );
      break;
    default:
      activeDocComponent = null;
  }

  window.ncs = props.newCaseSchedule;
  return (
    <div className={css(styles.dashboardContainer)}>
      {/* Discad Dialog 1 */}
      {props.showNewCaseScheduleWarningDialog1 &&
        <DialogBox
          showCloseBtn={false}
          initWidth={DIALOG_WIDTH}
          top={window.innerWidth <= 576 ? 48 : null}
          left={window.innerWidth <= 576 ? 8 : null}
          initHeight={210}
          isOpen={props.showNewCaseScheduleWarningDialog1}
          onClose={() => {
            props.toggleNewCaseScheduleWarningDialog1(false);
          }}
          maskBackground="#004080"
          maskOpacity={0.5}
          closeOnEscKey
          closeOnMaskClick={false}
          header={{
            overrideTheme: true,
            text: 'Warning! You Have Unsaved Changes!',
            backColor: '#082840',
            foreColor: 'yellow',
            closeColor: '#FF6060',
            fontStyle: 'bold',
            fontSize: '14px',
            icon: 'fa fa-exclamation-triangle'
          }}
        >
          <div className='p-2'>
            <div className='p-2 text-center'>
              What do you want to do?
            </div>
            <Button
              className='mt-4'
              btnType='danger'
              style={{
                height: '32px',
                width: '334px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onClick={() => {
                props.toggleNewCaseScheduleWarningDialog1(false);
                props.toggleNewCaseScheduleWarningDialog2(true);
              }}
            >
              Do Not Save
            </Button>
            <Button
              className='mt-4'
              btnType='primary'
              isOutlineBtn
              style={{
                border: `1px solid ${gray[400]}`,
                color: gray[300],
                height: '32px',
                width: '334px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onClick={() => props.toggleNewCaseScheduleWarningDialog1(false)}
            >
              Cancel
            </Button>
          </div>
        </DialogBox>
      }

      {/* Discad Dialog 2 */}
      {props.showNewCaseScheduleWarningDialog2 &&
        <DialogBox
          showCloseBtn={false}
          initWidth={DIALOG_WIDTH}
          top={window.innerWidth <= 576 ? 48 : null}
          left={window.innerWidth <= 576 ? 8 : null}
          initHeight={210}
          isOpen={props.showNewCaseScheduleWarningDialog2}
          onClose={() => {
            props.toggleNewCaseScheduleWarningDialog2(false);
          }}
          maskBackground="#004080"
          maskOpacity={0.5}
          closeOnEscKey
          closeOnMaskClick={false}
          header={{
            overrideTheme: true,
            text: 'Really?',
            backColor: '#082840',
            foreColor: 'yellow',
            closeColor: '#FF6060',
            fontStyle: 'bold',
            fontSize: '14px',
            icon: 'fa fa-exclamation-triangle'
          }}
        >
          <div className='p-2'>
            <div className='p-2 text-center'>
              Are you 100% sure?
            </div>
            <Button
              className='mt-4'
              btnType='danger'
              style={{
                height: '32px',
                width: '334px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onClick={() => {
                props.toggleNewCaseScheduleWarningDialog2(false);
                if (!props.forCaseBlocks) {
                  props.collapseReload();
                  const loadGanttGrid = JSON.parse(localStorage.getItem('loadGanttGrid'));
                  if (loadGanttGrid) {
                    localStorage.setItem("loadGanttGrid", JSON.stringify(false));
                    history.push('/schedule/gantt');
                  } else {
                    history.push('/schedule');
                  }
                } else {
                  props.collapseReload();
                  props.toggleScheduleCaseDrawer(false);
                  localStorage.setItem("loadGanttGrid", JSON.stringify(false));
                  history.push('/schedule/gantt');
                }
              }}
            >
              Do Not Save... I am 100% sure
            </Button>
            <Button
              className='mt-4'
              btnType='primary'
              isOutlineBtn
              style={{
                border: `1px solid ${gray[400]}`,
                color: gray[300],
                height: '32px',
                width: '334px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onClick={() => props.toggleNewCaseScheduleWarningDialog2(false)}
            >
              Cancel
            </Button>
          </div>
        </DialogBox>
      }

      {/* Camera drawer */}
      {showCameraDrawer &&
        <CameraDrawer
          caseDocs={newCaseScannedDocs.caseDocs}
          onClose={handleOnCloseCameraDrawer}
          onScan={handleOnScanCameraDrawer}
        />
      }

      {/* Cam Inspector Drawer */}
      {showCamInspectorDrawer &&
        <CamInspectorDrawer
          newImageUrl={newCaseScannedDocs.newImageUrl}
          caseDocs={newCaseScannedDocs.caseDocs}
          selectedDocument={newCaseScannedDocs.selectedPageId}
          onClickCancel={handleOnCancelScanDocs}
          onRetake={handleOnRetakeScanDocs}
          onClose={handleOnCloseScanDocs}
        />
      }

      {/* Cropper Drawer */}
      {showCropperDrawer &&
        <CropperDrawer
          isNewCase
          formType={cropperDocs.formType}
          caseDocs={cropperDocs.caseDocs}
          activeDocId={cropperDocs.selectedPageId}
          // cropperImgUrl={selectedPageDataUrl}
          onClose={handleOnCropperClose}
        // onCloseDocWriter={handleOnCloseDocWriter}
        />
      }

      {/* --  Main Header ------------------------------------------- */}
      <div className={css(styles.header)}>
        {/* Left side */}
        <div className='fx fx__hv-center'>
          <div className={`pl-1 ${css(styles.headerText)}`}>
            New Case
          </div>
        </div>

        {/* Right side - (Post Case | Discard Case Buttons) */}
        <div className='fx fx__hv-center'>
          {/* Discard Case Button */}
          <Button
            btnType='warning'
            className='fx fx__hv-center'
            style={{
              height: '32px',
              width: '90px',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            onClick={() => {
              if (!props.forCaseBlocks) {
                if (isEqual(window.icd, props.newCaseSchedule)) {
                  props.collapseReload();
                  const loadGanttGrid = JSON.parse(localStorage.getItem('loadGanttGrid'));
                  if (loadGanttGrid) {
                    localStorage.setItem("loadGanttGrid", JSON.stringify(false));
                    history.push('/schedule/gantt');
                  } else {
                    history.push('/schedule');
                  }
                } else {
                  props.toggleNewCaseScheduleWarningDialog1(true);
                }
              } else {
                if (isEqual(window.icd, props.caseBlockActiveCaseSchedule)) {
                  props.collapseReload();
                  props.toggleScheduleCaseDrawer(false);
                } else {
                  props.toggleNewCaseScheduleWarningDialog1(true);
                }
              }
            }}
          >
            <div className='fx fx__hv-center'>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="18"
                fill="none"
                className='mr-2'
              >
                <path fill="#fff" fillRule="evenodd" d="M10.5 1H14v2H0V1h3.5l1-1h5l1 1ZM3 18c-1.1 0-2-.9-2-2V4h12v12c0 1.1-.9 2-2 2H3Z" clipRule="evenodd" />
              </svg>
              <span>Discard</span>
            </div>
          </Button>
          {/* Post Case Button */}
          <Button
            btnType='primary'
            isDisabled={
              !props.newCaseSchedule.showScheduleStartDayOfWeek ||
              !props.newCaseSchedule.showScheduleEndDayOfWeek
            }
            className='ml-2 fx fx__hv-center'
            style={{
              height: '32px',
              width: '115px',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            onClick={() => {
              if (!props.forCaseBlocks) {
                const loadGanttGrid = JSON.parse(localStorage.getItem('loadGanttGrid'));
                let tmpNewCaseScheduleData = {
                  ...props.newCaseSchedule,
                  practiceNpi: props.selectedPractice.npi,
                  patientId: props.newCaseSchedulePatient._id
                };
                // FaceSheet docs
                if (faceSheetDocs.length > 0) {
                  tmpNewCaseScheduleData = {
                    ...tmpNewCaseScheduleData,
                    faceSheetDocs
                  };
                }
                // Records Labs Docs
                if (labsDocs.length > 0) {
                  tmpNewCaseScheduleData = {
                    ...tmpNewCaseScheduleData,
                    labsDocs
                  };
                }
                // Records EKG
                if (ekgDocs.length > 0) {
                  tmpNewCaseScheduleData = {
                    ...tmpNewCaseScheduleData,
                    ekgDocs
                  };
                }
                // Records Imaging
                if (imagingDocs.length > 0) {
                  tmpNewCaseScheduleData = {
                    ...tmpNewCaseScheduleData,
                    imagingDocs
                  };
                }
                // Records Consults
                if (consultsDocs.length > 0) {
                  tmpNewCaseScheduleData = {
                    ...tmpNewCaseScheduleData,
                    consultsDocs
                  };
                }
                // Consent Surgery
                if (consentSurgFormDocs.length > 0) {
                  tmpNewCaseScheduleData = {
                    ...tmpNewCaseScheduleData,
                    consentSurgFormDocs
                  };
                }
                // Consent Anesthesia
                if (consentFormDocs.length > 0) {
                  tmpNewCaseScheduleData = {
                    ...tmpNewCaseScheduleData,
                    consentFormDocs
                  };
                }
                // Nursing Docs
                if (nursingDocs.length > 0) {
                  tmpNewCaseScheduleData = {
                    ...tmpNewCaseScheduleData,
                    nursingDocs
                  };
                }
                // Surgeons Docs
                if (surgeonDocs.length > 0) {
                  tmpNewCaseScheduleData = {
                    ...tmpNewCaseScheduleData,
                    surgeonDocs
                  };
                }
                // Anesthesia Preop
                if (preOpFormDocs.length > 0) {
                  tmpNewCaseScheduleData = {
                    ...tmpNewCaseScheduleData,
                    preOpFormDocs
                  };
                }
                // Anesthesia IntraOp
                if (intraOpFormDocs.length > 0) {
                  tmpNewCaseScheduleData = {
                    ...tmpNewCaseScheduleData,
                    intraOpFormDocs
                  };
                }
                // Anesthesia PostOp
                if (postOpFormDocs.length > 0) {
                  tmpNewCaseScheduleData = {
                    ...tmpNewCaseScheduleData,
                    postOpFormDocs
                  };
                }
                // Discharge Docs
                if (dischargeDocs.length > 0) {
                  tmpNewCaseScheduleData = {
                    ...tmpNewCaseScheduleData,
                    dischargeDocs
                  };
                }
                // props.createNewCaseSchedule({
                //   ...props.newCaseSchedule,
                //   practiceNpi: props.selectedPractice.npi,
                //   patientId: props.newCaseSchedulePatient._id
                // },
                // props.selectedPractice);
                props.createNewCaseSchedule({
                  ...tmpNewCaseScheduleData,
                  practiceNpi: props.selectedPractice.npi,
                  patientId: props.newCaseSchedulePatient._id
                },
                props.selectedPractice);
                props.collapseReload();
                if (loadGanttGrid) {
                  localStorage.setItem("loadGanttGrid", JSON.stringify(false));
                  history.push('/schedule/gantt');
                } else {
                  history.push('/schedule');
                }
              } else {
                if (props.caseBlockActiveCaseSchedule.isNew) {
                  props.updateCaseBlockCaseMarkedForCreation();
                } else {
                  props.markCaseBlockCaseForCreation();
                }
                props.toggleScheduleCaseDrawer(false);
                history.push('/schedule/gantt');
              }
            }}
          >
            <div className='fx fx__hv-center'>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="none"
                className='mr-2'
              >
                <path fill="#fff" fillRule="evenodd" d="M18 4.21h-4V2.106C14 .937 13.11 0 12 0H8C6.89 0 6 .937 6 2.105v2.106H2C.89 4.21.01 5.147.01 6.316L0 17.895C0 19.063.89 20 2 20h16c1.11 0 2-.937 2-2.105V6.315c0-1.168-.89-2.104-2-2.104ZM12 4H8V2h4v2Zm-4.082 7.717a.793.793 0 0 1-1.175 0 .925.925 0 0 1 0-1.252L9.753 7.26a.797.797 0 0 1 1.175 0l3.01 3.205a.925.925 0 0 1 0 1.252.797.797 0 0 1-1.174 0l-1.59-1.694v6.089c0 .49-.374.888-.831.888-.46 0-.831-.398-.831-.886v-6.091l-1.593 1.694Z" clipRule="evenodd" />
              </svg>
              <span>Post Case</span>
            </div>
          </Button>
        </div>
      </div>

      {/* --  Main Dashboard Container ------------------------------ */}
      <div className={css(styles.sectionsContainer)}>
        {/* --- Case Docs Tabs & Patient Sticker -------- */}
        <div className={css(styles.tabsContainer)}>
          {/* Patient Sticker Container */}
          <div className={css(styles.patientStickerContainer)}>
            <PatientCard
              onClickCase={openCasePatientDrawer}
              flagType={findFlag(props.caseTabFlag, patientFlag, payerFlag)}
              patientData={patientData}
            />
          </div>

          {/* Document Tabs */}
          <div className={css(styles.docTabs)}>
            <TabsContainer
              dropDownId="caseSchedule_main_tabs"
              showPlusIcon={false}
              isDrawer={false}
              shiftMethod='minWidth'
              minWidth={610}
              containerStyles={{ width: '100%' }}
            >
              {TABS.map((tab) => {
                if (window.innerWidth <= BREAK_POINT) {
                  if (!tab.hideOnMobile) {
                    return (
                      <TabItem
                        key={tab.id}
                        tabKey={tab.id}
                        parentKey={tab.pKey}
                        text={tab.text}
                        isActive={activeTab === tab.text}
                        showTabIcon
                        showSvgIcon
                        svgIcon={(() => {
                          switch (tab.text) {
                            case 'FaceSheet':
                              if (isNoneFaceSheet) {
                                // return <DocumentNoneIcon />;
                                return IS_NONE_ICON;
                              }
                              if (faceSheetDocs.length > 0 || isNoneFaceSheet) {
                                // return <DocumentSuccessIcon />;
                                return SUCCESS_ICON;
                              }
                              // return <DocumentWarningIcon />;
                              return BELL_ICON;
                            case 'Results': {
                              if (isNoneLabDocs && isNoneEkgDocs && isNoneImagingDocs && isNoneConsults) {
                                return IS_NONE_ICON;
                              }
                              // Labs Flag
                              let labsFlag = FLAG_VALUE.warning;
                              if (isNoneLabDocs) {
                                labsFlag = FLAG_VALUE.none;
                              } else {
                                labsFlag = labsDocs.length > 0 ? FLAG_VALUE.success : FLAG_VALUE.warning;
                              }
                              // EKG Flag
                              let ekgFlag = FLAG_VALUE.warning;
                              if (isNoneEkgDocs) {
                                ekgFlag = FLAG_VALUE.none;
                              } else {
                                ekgFlag = ekgDocs.length > 0 ? FLAG_VALUE.success : FLAG_VALUE.warning;
                              }
                              // Imaging Flag
                              let imagingFlag = FLAG_VALUE.warning;
                              if (isNoneImagingDocs) {
                                imagingFlag = FLAG_VALUE.none;
                              } else {
                                imagingFlag = imagingDocs.length > 0 ? FLAG_VALUE.success : FLAG_VALUE.warning;
                              }
                              // Consults Flag
                              let consultsFlag = FLAG_VALUE.warning;
                              if (isNoneConsults) {
                                consultsFlag = FLAG_VALUE.none;
                              } else {
                                consultsFlag = consultsDocs.length > 0 ? FLAG_VALUE.success : FLAG_VALUE.warning;
                              }

                              const resultsFlag = findFlag(labsFlag, ekgFlag, imagingFlag, consultsFlag);

                              console.log(`▶️ labsFlag = ${labsFlag}`);
                              console.log(`▶️ ekgFlag = ${ekgFlag}`);
                              console.log(`▶️ imagingFlag = ${imagingFlag}`);
                              console.log(`▶️ consultsFlag = ${consultsFlag}`);
                              console.log(`▶️ resultsFlag = ${resultsFlag}`);

                              switch (resultsFlag) {
                                case FLAG_VALUE.none:
                                  return IS_NONE_ICON;
                                case FLAG_VALUE.success:
                                  return SUCCESS_ICON;
                                case FLAG_VALUE.warning:
                                default:
                                  return BELL_ICON;
                              }
                            }
                            case 'Consents': {
                              if (isNoneConsentSurgFormDocs && isNoneConsentFormDocs) {
                                return IS_NONE_ICON;
                              }

                              // Surgery consent flag
                              let surgConsentFlag = FLAG_VALUE.warning;
                              if (isNoneConsentSurgFormDocs) {
                                surgConsentFlag = FLAG_VALUE.none;
                              } else {
                                surgConsentFlag = consentSurgFormDocs.length > 0 ? FLAG_VALUE.success : FLAG_VALUE.warning;
                              }

                              // Anesthesia consent flag
                              let anesConsentFlag = FLAG_VALUE.warning;
                              if (isNoneConsentFormDocs) {
                                anesConsentFlag = FLAG_VALUE.none;
                              } else {
                                anesConsentFlag = consentFormDocs.length > 0 ? FLAG_VALUE.success : FLAG_VALUE.warning;
                              }

                              const consentFlag = findFlag(surgConsentFlag, anesConsentFlag);
                              switch (consentFlag) {
                                case FLAG_VALUE.none:
                                  return IS_NONE_ICON;
                                case FLAG_VALUE.success:
                                  return SUCCESS_ICON;
                                case FLAG_VALUE.warning:
                                default:
                                  return BELL_ICON;
                              }
                            }
                            case 'Anesthesia': {
                              if (isNonePreOpFormDocs && isNoneIntraOpFormDocs && isNonePostOpFormDocs && isNoneAnesthesiaProcedure) {
                                return IS_NONE_ICON;
                              }

                              const preOPFlag = preOpFormDocs.length > 0 || isNonePreOpFormDocs;
                              const intraOpFlag = intraOpFormDocs.length > 0 || isNoneIntraOpFormDocs;
                              const postOpFlag = postOpFormDocs.length > 0 || isNonePostOpFormDocs;
                              let procFlag = false;
                              if (isNoneAnesthesiaProcedure) {
                                procFlag = true;
                              } else if (anesthesiaProcedures.length === 0) {
                                procFlag = false;
                              } else if (anesthesiaProcedures.length > 0 && (anesthesiaProcedures.filter(el => el.npi === 0)).length > 0) {
                                procFlag = false;
                              } else {
                                procFlag = true;
                              }

                              if (preOPFlag && intraOpFlag && postOpFlag && procFlag) {
                                return SUCCESS_ICON;
                              }
                              return BELL_ICON;
                            }
                            case 'Nursing':
                              if (isNoneNursingDocs) {
                                return IS_NONE_ICON;
                              }
                              if (nursingDocs.length > 0 || isNoneNursingDocs) {
                                return SUCCESS_ICON;
                              }
                              return BELL_ICON;
                            case 'Surgeon':
                              if (isNoneSurgeonDocs) {
                                return IS_NONE_ICON;
                              }
                              if (surgeonDocs.length > 0 || isNoneSurgeonDocs) {
                                return SUCCESS_ICON;
                              }
                              return BELL_ICON;
                            case 'Discharge':
                              if (isNoneDischargeDocs) {
                                return IS_NONE_ICON;
                              }
                              if (dischargeDocs.length > 0 || isNoneDischargeDocs) {
                                return SUCCESS_ICON;
                              }
                              return BELL_ICON;
                            case 'Orders': {
                              if (isNoneOrdersPreOpDocs && isNoneOrdersIntraOpDocs && isNoneOrdersPostOpDocs) {
                                return IS_NONE_ICON;
                              }
                              const preOPFlag = ordersPreOpDocs.length > 0 || isNoneOrdersPreOpDocs;
                              const intraOpFlag = ordersIntraOpDocs.length > 0 || isNoneOrdersIntraOpDocs;
                              const postOpFlag = ordresPostOpDocs.length > 0 || isNoneOrdersPostOpDocs;

                              if (preOPFlag && intraOpFlag && postOpFlag) {
                                return SUCCESS_ICON;
                              }
                              return BELL_ICON;
                            }
                            default:
                              return BELL_ICON;
                          }
                        })()}
                        style={{
                          ...tab.styles,
                          background: activeTab === tab.text ? '#184878' : '#083050'
                        }}
                        textStyles={TABS_TEXT_STYLES}
                        onActivate={() => {
                          setActiveTab(tab.text);
                        }}
                      >
                        {!tab.isIconText ? tab.text : tab.textIcon}
                      </TabItem>
                    );
                  }
                } else {
                  return (
                    <TabItem
                      key={tab.id}
                      tabKey={tab.id}
                      parentKey={tab.pKey}
                      text={tab.text}
                      isActive={activeTab === tab.text}
                      showTabIcon
                      showSvgIcon
                      svgIcon={(() => {
                        switch (tab.text) {
                          case 'FaceSheet':
                            if (isNoneFaceSheet) {
                              // return <DocumentNoneIcon />;
                              return IS_NONE_ICON;
                            }
                            if (faceSheetDocs.length > 0 || isNoneFaceSheet) {
                              // return <DocumentSuccessIcon />;
                              return SUCCESS_ICON;
                            }
                            // return <DocumentWarningIcon />;
                            return BELL_ICON;
                          case 'Results': {
                            if (isNoneLabDocs && isNoneEkgDocs && isNoneImagingDocs && isNoneConsults) {
                              return IS_NONE_ICON;
                            }
                            // Labs Flag
                            let labsFlag = FLAG_VALUE.warning;
                            if (isNoneLabDocs) {
                              labsFlag = FLAG_VALUE.none;
                            } else {
                              labsFlag = labsDocs.length > 0 ? FLAG_VALUE.success : FLAG_VALUE.warning;
                            }
                            // EKG Flag
                            let ekgFlag = FLAG_VALUE.warning;
                            if (isNoneEkgDocs) {
                              ekgFlag = FLAG_VALUE.none;
                            } else {
                              ekgFlag = ekgDocs.length > 0 ? FLAG_VALUE.success : FLAG_VALUE.warning;
                            }
                            // Imaging Flag
                            let imagingFlag = FLAG_VALUE.warning;
                            if (isNoneImagingDocs) {
                              imagingFlag = FLAG_VALUE.none;
                            } else {
                              imagingFlag = imagingDocs.length > 0 ? FLAG_VALUE.success : FLAG_VALUE.warning;
                            }
                            // Consults Flag
                            let consultsFlag = FLAG_VALUE.warning;
                            if (isNoneConsults) {
                              consultsFlag = FLAG_VALUE.none;
                            } else {
                              consultsFlag = consultsDocs.length > 0 ? FLAG_VALUE.success : FLAG_VALUE.warning;
                            }

                            const resultsFlag = findFlag(labsFlag, ekgFlag, imagingFlag, consultsFlag);
                            switch (resultsFlag) {
                              case FLAG_VALUE.none:
                                return IS_NONE_ICON;
                              case FLAG_VALUE.success:
                                return SUCCESS_ICON;
                              case FLAG_VALUE.warning:
                              default:
                                return BELL_ICON;
                            }
                          }
                          case 'Consents': {
                            if (isNoneConsentSurgFormDocs && isNoneConsentFormDocs) {
                              return IS_NONE_ICON;
                            }

                            // Surgery consent flag
                            let surgConsentFlag = FLAG_VALUE.warning;
                            if (isNoneConsentSurgFormDocs) {
                              surgConsentFlag = FLAG_VALUE.none;
                            } else {
                              surgConsentFlag = consentSurgFormDocs.length > 0 ? FLAG_VALUE.success : FLAG_VALUE.warning;
                            }

                            // Anesthesia consent flag
                            let anesConsentFlag = FLAG_VALUE.warning;
                            if (isNoneConsentFormDocs) {
                              anesConsentFlag = FLAG_VALUE.none;
                            } else {
                              anesConsentFlag = consentFormDocs.length > 0 ? FLAG_VALUE.success : FLAG_VALUE.warning;
                            }

                            const consentFlag = findFlag(surgConsentFlag, anesConsentFlag);
                            switch (consentFlag) {
                              case FLAG_VALUE.none:
                                return IS_NONE_ICON;
                              case FLAG_VALUE.success:
                                return SUCCESS_ICON;
                              case FLAG_VALUE.warning:
                              default:
                                return BELL_ICON;
                            }
                          }
                          case 'Anesthesia': {
                            if (isNonePreOpFormDocs && isNoneIntraOpFormDocs && isNonePostOpFormDocs && isNoneAnesthesiaProcedure) {
                              return IS_NONE_ICON;
                            }

                            const preOPFlag = preOpFormDocs.length > 0 || isNonePreOpFormDocs;
                            const intraOpFlag = intraOpFormDocs.length > 0 || isNoneIntraOpFormDocs;
                            const postOpFlag = postOpFormDocs.length > 0 || isNonePostOpFormDocs;
                            let procFlag = false;
                            if (isNoneAnesthesiaProcedure) {
                              procFlag = true;
                            } else if (anesthesiaProcedures.length === 0) {
                              procFlag = false;
                            } else if (anesthesiaProcedures.length > 0 && (anesthesiaProcedures.filter(el => el.npi === 0)).length > 0) {
                              procFlag = false;
                            } else {
                              procFlag = true;
                            }

                            if (preOPFlag && intraOpFlag && postOpFlag && procFlag) {
                              return SUCCESS_ICON;
                            }
                            return BELL_ICON;
                          }
                          case 'Nursing':
                            if (isNoneNursingDocs) {
                              return IS_NONE_ICON;
                            }
                            if (nursingDocs.length > 0 || isNoneNursingDocs) {
                              return SUCCESS_ICON;
                            }
                            return BELL_ICON;
                          case 'Surgeon':
                            if (isNoneSurgeonDocs) {
                              return IS_NONE_ICON;
                            }
                            if (surgeonDocs.length > 0 || isNoneSurgeonDocs) {
                              return SUCCESS_ICON;
                            }
                            return BELL_ICON;
                          case 'Discharge':
                            if (isNoneDischargeDocs) {
                              return IS_NONE_ICON;
                            }
                            if (dischargeDocs.length > 0 || isNoneDischargeDocs) {
                              return SUCCESS_ICON;
                            }
                            return BELL_ICON;
                          case 'Orders': {
                            if (isNoneOrdersPreOpDocs && isNoneOrdersIntraOpDocs && isNoneOrdersPostOpDocs) {
                              return IS_NONE_ICON;
                            }
                            const preOPFlag = ordersPreOpDocs.length > 0 || isNoneOrdersPreOpDocs;
                            const intraOpFlag = ordersIntraOpDocs.length > 0 || isNoneOrdersIntraOpDocs;
                            const postOpFlag = ordresPostOpDocs.length > 0 || isNoneOrdersPostOpDocs;

                            if (preOPFlag && intraOpFlag && postOpFlag) {
                              return SUCCESS_ICON;
                            }
                            return BELL_ICON;
                          }
                          default:
                            return BELL_ICON;
                        }
                      })()}
                      svgIcon2={(() => {
                        switch (tab.text) {
                          case 'FaceSheet':
                            if (isNoneFaceSheet) {
                              return <DocumentNoneIcon height={20} />;
                            }
                            if (faceSheetDocs.length > 0 || isNoneFaceSheet) {
                              return <DocumentSuccessIcon height={18} />;
                            }
                            return <DocumentWarningIcon height={20} />;
                          case 'Records': {
                            if (isNoneLabDocs && isNoneEkgDocs && isNoneImagingDocs && isNoneConsults) {
                              return <DocumentNoneIcon height={20} />;
                            }

                            const labsFlag = labsDocs.length > 0 || isNoneLabDocs;
                            const ekgFlag = ekgDocs.length > 0 || isNoneEkgDocs;
                            const imagingFlag = imagingDocs.length > 0 || isNoneImagingDocs;
                            const consultsFlag = consultsDocs.length > 0 || isNoneConsults;

                            if (labsFlag && ekgFlag && imagingFlag && consultsFlag) {
                              return <DocumentSuccessIcon height={18} />;
                            }
                            return <DocumentWarningIcon height={20} />;
                          }
                          case 'Consents': {
                            if (isNoneConsentSurgFormDocs && isNoneConsentFormDocs) {
                              return <DocumentNoneIcon height={20} />;
                            }

                            const surgFlag = consentSurgFormDocs.length > 0 || isNoneConsentSurgFormDocs;
                            const anesFlag = consentFormDocs.length > 0 || isNoneConsentFormDocs;

                            if (surgFlag && anesFlag) {
                              return <DocumentSuccessIcon height={18} />;
                            }
                            return <DocumentWarningIcon height={20} />;
                          }
                          case 'Anesthesia': {
                            if (isNonePreOpFormDocs && isNoneIntraOpFormDocs && isNonePostOpFormDocs && isNoneAnesthesiaProcedure) {
                              return <DocumentNoneIcon height={20} />;
                            }

                            const preOPFlag = preOpFormDocs.length > 0 || isNonePreOpFormDocs;
                            const intraOpFlag = intraOpFormDocs.length > 0 || isNoneIntraOpFormDocs;
                            const postOpFlag = postOpFormDocs.length > 0 || isNonePostOpFormDocs;
                            let procFlag = false;
                            if (isNoneAnesthesiaProcedure) {
                              procFlag = true;
                            } else if (anesthesiaProcedures.length === 0) {
                              procFlag = false;
                            } else if (anesthesiaProcedures.length > 0 && (anesthesiaProcedures.filter(el => el.npi === 0)).length > 0) {
                              procFlag = false;
                            } else {
                              procFlag = true;
                            }

                            if (preOPFlag && intraOpFlag && postOpFlag && procFlag) {
                              return <DocumentSuccessIcon height={18} />;
                            }
                            return <DocumentWarningIcon height={20} />;
                          }
                          case 'Nursing':
                            if (isNoneNursingDocs) {
                              return <DocumentNoneIcon height={20} />;
                            }
                            if (nursingDocs.length > 0 || isNoneNursingDocs) {
                              return <DocumentSuccessIcon height={18} />;
                            }
                            return <DocumentWarningIcon height={20} />;
                          case 'Surgeon':
                            if (isNoneSurgeonDocs) {
                              return <DocumentNoneIcon height={20} />;
                            }
                            if (surgeonDocs.length > 0 || isNoneSurgeonDocs) {
                              return <DocumentSuccessIcon height={18} />;
                            }
                            return <DocumentWarningIcon height={20} />;
                          case 'Discharge':
                            if (isNoneDischargeDocs) {
                              return <DocumentNoneIcon height={20} />;
                            }
                            if (dischargeDocs.length > 0 || isNoneDischargeDocs) {
                              return <DocumentSuccessIcon height={18} />;
                            }
                            return <DocumentWarningIcon height={20} />;
                          case 'Orders': {
                            if (isNoneOrdersPreOpDocs && isNoneOrdersIntraOpDocs && isNoneOrdersPostOpDocs) {
                              return <DocumentNoneIcon height={20} />;
                            }
                            const preOPFlag = ordersPreOpDocs.length > 0 || isNoneOrdersPreOpDocs;
                            const intraOpFlag = ordersIntraOpDocs.length > 0 || isNoneOrdersIntraOpDocs;
                            const postOpFlag = ordresPostOpDocs.length > 0 || isNoneOrdersPostOpDocs;

                            if (preOPFlag && intraOpFlag && postOpFlag) {
                              return <DocumentSuccessIcon height={18} />;
                            }
                            return <DocumentWarningIcon height={20} />;
                          }
                          default:
                            return BELL_ICON;
                        }
                      })()}
                      style={{
                        ...tab.styles,
                        background: activeTab === tab.text ? '#184878' : '#083050'
                      }}
                      textStyles={TABS_TEXT_STYLES}
                      onActivate={() => {
                        setActiveTab(tab.text);
                      }}
                    >
                      {!tab.isIconText ? tab.text : tab.textIcon}
                    </TabItem>
                  );
                }
              })}
            </TabsContainer>
          </div>

          {/* Active Component - Doc Container */}
          <div className={css(styles.docContainer)}>
            {activeDocComponent}
          </div>
        </div>
        {/* --- Schedule Drawer -------- */}
        <div
          className={css(styles.scheduleFormContainer,
            isMobileLayout && styles.scheduleFormContainerMobile,
            !showScheduleDrawer && styles.scheduleFormContainerClosed
          )}
        >
          {/* Header */}
          <div className={css(styles.scheduleFormHeader)}>
            {/* Header Text */}
            <div className={css(styles.scheduleFormHeaderTitle)}>
              {masterFlag === FLAG_VALUE.success && <CaseSuccessIcon />}
              {masterFlag === FLAG_VALUE.warning && <CaseWarningIcon />}
              {masterFlag === FLAG_VALUE.critical && <CaseCriticalIcon />}
              <span className='ml-2'>
                Case Posting
              </span>
            </div>
            {/* Close Icon */}
            <div className={css(styles.scheduleFormHeaderCloseIcon)}>
              <i
                className='fa fa-times-circle'
                onClick={closeScheduleCaseDrawer}
              />
            </div>
          </div>
          {/* Schedule Drawer Tabs */}
          <div className={css(styles.scheduleDrawerTabs)}>
            <TabsContainer
              dropDownId="new_case_post_drawer_tabs"
              showPlusIcon={false}
              isDrawer={false}
              shiftMethod='minWidth'
              minWidth={315}
            >
              {/* Case Tab */}
              <TabItem
                key='1211'
                tabKey='1211'
                parentKey='1200'
                text='Case'
                isActive={drawerActiveTab === 'case'}
                showTabIcon
                showSvgIcon
                svgIcon={(() => {
                  switch (props.caseTabFlag) {
                    case FLAG_VALUE.success:
                      return SUCCESS_ICON;
                    case FLAG_VALUE.warning:
                      return BELL_ICON;
                    case FLAG_VALUE.critical:
                    default:
                      return CRITIAL_ICON;
                  }
                })()}
                style={{
                  ...COMMON_TAB_ITEM_STYLES,
                  width: '90px',
                  minWidth: '90px',
                  maxWidth: '90px',
                  border: `1px solid ${gray[600]}`,
                  background: drawerActiveTab === 'case' ? blue[800] : gray[800]
                }}
                textStyles={TABS_TEXT_STYLES}
                onActivate={() => {
                  handleOnActivateDrawerTab('case');
                }}
              >
                Case
              </TabItem>
              {/* Patient Tab */}
              <TabItem
                key='1212'
                tabKey='1212'
                parentKey='1201'
                text='Patient'
                isActive={drawerActiveTab === 'patient'}
                showTabIcon
                showSvgIcon
                svgIcon={patientFlag === FLAG_VALUE.success ? SUCCESS_ICON : BELL_ICON}
                style={{
                  ...COMMON_TAB_ITEM_STYLES,
                  width: '100px',
                  minWidth: '100px',
                  maxWidth: '100px',
                  border: `1px solid ${gray[600]}`,
                  background: drawerActiveTab === 'patient' ? blue[800] : gray[800]
                }}
                textStyles={TABS_TEXT_STYLES}
                onActivate={() => {
                  handleOnActivateDrawerTab('patient');
                }}
              >
                Patient
              </TabItem>
              {/* Payers Tab */}
              <TabItem
                key='1213'
                tabKey='1214'
                parentKey='1301'
                text='Payers'
                isActive={drawerActiveTab === 'payers'}
                showTabIcon
                showSvgIcon
                svgIcon={payerFlag === FLAG_VALUE.success ? SUCCESS_ICON : BELL_ICON}
                style={{
                  ...COMMON_TAB_ITEM_STYLES,
                  width: '100px',
                  minWidth: '100px',
                  maxWidth: '100px',
                  border: `1px solid ${gray[600]}`,
                  background: drawerActiveTab === 'payers' ? blue[800] : gray[800]
                }}
                textStyles={TABS_TEXT_STYLES}
                onActivate={() => {
                  handleOnActivateDrawerTab('payers');
                }}
              >
                Payers
              </TabItem>
            </TabsContainer>
          </div>
          {/* Active Component */}
          <div className={css(styles.activeComponentContainer)}>
            {activeDrawerComponent}
          </div>
        </div>
      </div>
    </div>
  );
};

ScheduleCaseDrawer2.defaultProps = {
  forCaseBlocks: false,
  caseBlockId: null,
  origin: ORIGIN.scheduleGrid
};

function mapStateToProps({ caseSchedule }) {
  return { ...caseSchedule };
}

export default connect(mapStateToProps, {
  createNewCaseSchedule,
  addPatientToNewCaseSchedule,
  setOpMode,
  updateNewCaseScheduleData,
  toggleNewCaseScheduleWarningDialog1,
  toggleNewCaseScheduleWarningDialog2,
  reloadCaseSchedulePatientData,
  shouldResyncCaseData,
  initiateNewCaseSchedule,
  markCaseBlockCaseForCreation,
  toggleScheduleCaseDrawer,
  updateCaseBlockActiveCaseSchedule,
  addPatientToCaseBlock,
  deletePatientFromNewCaseSchedule,
  deletePatientFromCaseSchedule,
  deletePatientFromCaseBlock,
  reloadCaseBlockCasePatientData,
  updateCaseBlockCaseMarkedForCreation,
  collapseReload
})(ScheduleCaseDrawer2);
